// This file is generated, don't edit manually!
i18n = typeof i18n == 'undefined' ? {} : i18n;
i18n.langs = {};
i18n.langs.cs = {
	"Agent je přihlášen ve {n} frontách": [
		"Agent je přihlášen v {n} frontě",
		"Agent je přihlášen ve {n} frontách",
		"Agent je přihlášen v {n} frontách"
	],
	"Importováno {n} záznamů": [
		"Importován {n} záznam",
		"Importovány {n} záznamy",
		"Importováno {n} záznamů"
	],
	"Service level": "Úroveň služby",
	"Vybráno *{n} adresářů*": [
		"Vybrán *{n} adresář*",
		"Vybrány *{n} adresáře*",
		"Vybráno *{n} adresářů*"
	],
	"Vybráno *{n} front*": [
		"Vybrána *{n} fronta*",
		"Vybrány *{n} fronty*",
		"Vybráno *{n} front*"
	],
	"Vybráno *{n} komunikačních kanálů*": [
		"Vybrán *{n} komunikační kanál*",
		"Vybrány *{n} komunikační kanály*",
		"Vybráno *{n} komunikačních kanálů*"
	],
	"Vybráno *{n} linek*": [
		"Vybrána *{n} linka*",
		"Vybrány *{n} linky*",
		"Vybráno *{n} linek*"
	],
	"Vybráno *{n} pauz*": [
		"Vybrána *{n} pauza*",
		"Vybrány *{n} pauzy*",
		"Vybráno *{n} pauz*"
	],
	"Vybráno *{n} položek*": [
		"Vybrána *{n} položka*",
		"Vybrány *{n} položky*",
		"Vybráno *{n} položek*"
	],
	"Vybráno *{n} uživatelů*": [
		"Vybrán *{n} uživatel*",
		"Vybráni *{n} uživatelé*",
		"Vybráno *{n} uživatelů*"
	],
	"Vybráno *{n} záložek*": [
		"Vybrána *{n} záožka*",
		"Vybrány *{n} záožky*",
		"Vybráno *{n} záložek*"
	],
	"Vybráno *{n} záznamníků*": [
		"Vybrána *{n} záznamník*",
		"Vybrána *{n} záznamníky*",
		"Vybrána *{n} záznamníků*"
	],
	"Vybráno *{n} časových podmínek*": [
		"Vybrána *{n} časová podmínka*",
		"Vybrány *{n} časové podmínky*",
		"Vybráno *{n} časových podmínek*"
	],
	"Vybráno *{n} šablon*": [
		"Vybrána *{n} šablona*",
		"Vybrány *{n} šablony*",
		"Vybráno *{n} šablon*"
	],
	"{n} záznamů se importovat nepodařilo": [
		"{n} záznam se importovat nepodařilo",
		"{n} záznamy se importovat nepodařilo",
		"{n} záznamů se importovat nepodařilo"
	],
	"__plural": function(n) { return (n==1) ? 0 : ((n>=2 && n<=4) ? 1 : 2); },
	"__nplurals": 3
};
i18n.langs.en = {
	"(wav, ogg/vorbis, mp3, ...)": "(wav, ogg/vorbis, mp3, ...)",
	"+420 261 303 303": "+420 261 303 303",
	"<{s}s": "<{s}s",
	">{s}s": "<{s}s",
	"ACL": "ACL",
	"ACL hovoru": "Call ACL",
	"AP": "AP",
	"API Geco pluginu": "Geco Plugin API",
	"API Malfini pluginu": "Malfini plugin API",
	"API Reportů - Staropramen": "Staropramen Reports API",
	"API Tester": "API Tester",
	"API URL": "API URL",
	"API key": "API key",
	"API pluginu pro Ekonomické stavby": "API plugin for Economic Buildings",
	"API pluginu pro Staropramen": "Staropramen plugin API",
	"API pro komunikační kanály a zprávy (SMS a WhatsApp)": "API for communication channels and messages (SMS and WhatsApp)",
	"API přístupy": "API access",
	"API výrobce telefonu": "Phone vendor API",
	"API výrobce telefonu (vyjma Yealink)": "Phone vendor API (except Yealink)",
	"API ČZU pluginu": "API of ČZU plugin",
	"Aby jste mohli pokračovat musíte souhlasit s podmínkami": "You need to agree to continue",
	"Access token": "Access token",
	"Administrace": "Administration",
	"Administrace PBX": "PBX administration",
	"Administrace ústředny": "PBX administration",
	"Administrační přehled": "Administration overview",
	"Administrátor ústředny": "PBX administrator",
	"Administrátorská příručka": "Administartor guide",
	"Adresář": "Directory",
	"Adresář kontaktů": "Contact directory",
	"Adresáře": "Directories",
	"Adresáře kontaktů": "Contact directories",
	"Adresáře můžete přidat výběrem z pravého sloupce": "You can add directories by selecting them from the right column",
	"Adresáře ve skupině": "Directories in a group",
	"Agent": "Agent",
	"Agent frontu nemá k dispozici": "No queues available to the agent",
	"Agent je považovaný jako volný vždy, když má aktivovanou externí linku.": "An agent is considered free whenever they have an active external line.",
	"Agent je přihlášen na externí lince": "Agent is logged into an external extension",
	"Agent je přihlášen v jedné frontě": "Agent is logged into one queue",
	"Agent je přihlášen ve frontách, ale nemá registrované žádné zařízení!": "Agent is logged into queues, but does not have any devices registered!",
	"Agent je přihlášen ve {n} frontách": [
		"Agent is logged into {n} queue",
		"Agent is logged into {n} queues"
	],
	"Agent může na záložce Agenti přihlašovat a odhlašovat ostatní agenty z a do front": "Agent can manage other agent's membership in queues in the Agent panel",
	"Agent není přihlášen ani v jedné frontě!": "Agent is not logged into any queue!",
	"Agent není přihlášen v žádné frontě": "Agent is not logged into any queue",
	"Agent panel": "Agent panel",
	"Agent vidí jen své nahrávky": "An agent sees only their own recordings",
	"Agenti": "Agents",
	"Agenti se mohou přihlásit/odhlásit jen do všech front": "Agents can join/leave only all queues at once",
	"Agentská": "Agent",
	"Agentské pracoviště kontaktního centra": "Agent contact center",
	"Agentský": "Agent’s",
	"Agentů v pauze": "Paused agents",
	"Akce": "Action",
	"Aktivita": "Activity",
	"Aktivita přehrání záznamu ze záznamníku": "Activity of recordings machine recording playback",
	"Aktivní": "Active",
	"Aktivní a čekající hovory": "Active and pending calls",
	"Aktivní hovory": "Active calls",
	"Aktivní záložky": "Active tabs",
	"Aktivovat": "Activate",
	"Aktivovat automatické opuštění": "Activate automatic exit",
	"Aktivovat kampaň": "Activate campaign",
	"Aktualizace probíhá": "Update in progress",
	"Aktuálně neprobíhá žádný hovor": "There is no call ongoing",
	"Alias": "Alias",
	"Alias volajícího": "Caller alias",
	"All-in-one komunikační platforma pro péči o zákazníky": "All-in-one communication platform for customer relations",
	"Angličtina": "English",
	"Ano": "Yes",
	"Ano, uzavřít i callback": "Yes, and close callback",
	"AoR pro registraci": "AoR for registration",
	"Aplikace": "Application",
	"Aplikace byla aktualizována na verzi {version}, je třeba obnovit stránku pro dokončení aktualizace.": "The application has been updated to version {version}. Please refresh the page to complete the update.",
	"Aplikace není nyní dostupná (server se restartuje, nebo selhal)": "Application is currently unavailable (server restarting or failed)",
	"Aplikace spojovatelka": "Switchboard application",
	"Aplikovat konfiguraci": "Apply configuration",
	"Archiv": "Archive",
	"Archivované": "Archived",
	"Archivovat": "Archive",
	"Archivovat kampaň": "Archive campaign",
	"Asistent": "Assistant",
	"Audio / RTP": "Audio / RTP",
	"Audio je nutné nahrát": "You must upload audio file",
	"Auto pauza [s]": "Autopause [s]",
	"Automaticky otevřít kartu hovoru při začátku zvonění.": "Automatically open the call card when ringing starts.",
	"Automaticky přepnout na novou kartu hovoru.": "Switch to the call info card automatically.",
	"Automaticky přepojit na linku": "Automatically transfer to the line",
	"Automaticky uzavřít kartu hovoru při nevyzvednutí hovoru.": "Close the card automatically when the call is not answered.",
	"Automatické opuštění": "Automatic exit",
	"Automatické otevření karty hovoru": "Automatic call info card activation",
	"Automatické vyzvednutí": "Autoanswer",
	"Automatický": "Automatic",
	"Autopauza": "Autopause",
	"Autorizační token": "Authorization token",
	"BC4 Kontaktní centrum": "BC4 Contact center",
	"Bez editace": "Editing disabled",
	"Bez filtru": "No filter",
	"Bez fronty": "No queue",
	"Bez povolených notifikací si nemusíte všimnout hovorů pokud máte okno na pozadí. Notifikace si můžete v budoucnu zapnout ručně.": "Without enabled notifications, you may miss calls if the window is in the background. You can manually enable notifications later.",
	"Bez projektu": "No project",
	"Bugreporty": "Bug reports",
	"Business Application ID (BA ID)": "Business Application ID (BA ID)",
	"Business account id": "Business account ID",
	"BusinessCom a.s.": "BusinessCom a.s.",
	"Během importu nastaly nějaké chyby": "Some errors occurred during import",
	"Běžné vyzvánění": "Normal ringing",
	"CALL IN": "CALL IN",
	"CALL OUT": "CALL OUT",
	"CALLBACK": "CALLBACK",
	"CDR": "CDR",
	"CDR Asterisk": "Asterisk CDR",
	"CDR QoS": "CDR QoS",
	"Call ID": "Call ID",
	"Call flow": "Call flow",
	"Call flow nenalezeno": "Call flow not found",
	"Callback": "Callback",
	"Callback - Graf uzavření případů": "Callback - Closed cases graph",
	"Callflow": "Callflow",
	"Celkem": "Total",
	"Celkem\nhovorů": "Total\ncalls",
	"Celkem In": "Total In",
	"Celkem Out": "Total Out",
	"Celkem callbacků": "Total callbacks",
	"Celkem hovorů": "Total calls",
	"Celkem příchozích": "Total incomming",
	"Celkem v pauze": "Total paused",
	"Celkem zmeškaných hovorů": "Total missed calls",
	"Celkem zmeškaných případů": "Total missed cases",
	"Celkem {time}": "Total {time}",
	"Celková\ndoba hovorů": "Total call duration",
	"Celková doba hovorů": "Total duration of calls",
	"Celková délka\nhovorů": "Total call\nduration",
	"Celková délka hovorů": "Total duration of calls",
	"Celkový počet čísel": "Total number of numbers",
	"Celkový počet čísel z kampaní": "Total number of numbers from campaigns",
	"Certifikát (.pem)": "Certificate (.pem)",
	"Chat": "Chat",
	"ChatGPT": "ChatGPT",
	"ChatGPT hlasový profil": "ChatGPT voice profile",
	"ChatGPT profily": "ChatGPT profiles",
	"Chcete se z těchto front odhlásit nebo v nich po odhlášení z aplikace zůstat?": "Do you want to log out from these queues or remain in them after logging out of the application?",
	"Chcete uzavřít i callback?": "Do you want to close callback, too?",
	"Chlívečkový": "Table",
	"Chování": "Behavior",
	"Chyba": "Error",
	"Chyba na řádce {n}: Zpráva je moc dlouhá.": "Error on line {n}: The message is too long.",
	"Chyba na řádce {n}: Žádné číslo.": "Error on line {n}: Missing number.",
	"Chyba při zobrazení zprávy: ": "Error displaying message: ",
	"Chyba serveru": "Server error",
	"Chyba v dialplánu, či jiná chyba systému": "Dialplan error or other system error",
	"Chyba: ": "Error: ",
	"Chybná e-mailová adresa": "Invalid e-mail address",
	"Chybná hodnota": "Invalid value",
	"Chybné číslo": "Wrong number",
	"Chybný formát datumu a času. Použijte d.m.r h:m nebo m/d/r h:m": "Invalid date/time format. Use d.m.y H:M, or m/d/y. H:M",
	"Chybný formát datumu. Použijte d.m.r nebo m/d/r": "Invalid date format. Use d.m.y, or m/d/y",
	"Chybný formát volaného čísla": "Incorrect called number format",
	"Chybný formát čísla": "Incorrect number format",
	"Chybný vstup": "Invalid input",
	"Could not delete used ChatGPT voice profile": "Could not delete a used ChatGPT voice profile",
	"Could not delete used user condition": "Could not delete a used user condition",
	"Cíl": "Target",
	"Cílová SIP proxy": "Target SIP proxy",
	"Cílová fronta": "Destination queue",
	"Cílová linka": "Destination extension",
	"Cílové call flow": "Destination call flow",
	"Cílové číslo": "Target number",
	"DID": "DID",
	"Data": "Data",
	"Data celé skupiny - všechny role vidí data celé skupiny": "Data for the whole group - all roles can view data for the whole group",
	"Data nejsou načtena": "Data are not loaded",
	"Data se načítají...": "Loading...",
	"Datové spojení bylo přerušeno": "Data connection has been dropped",
	"Datum": "Date",
	"Datum 1. urgence": "Date of first urgency",
	"Datum a čas": "Date and time",
	"Deaktivovat": "Deactivate",
	"Deaktivovat kampaň": "Deactivate campaign",
	"Debugovací panel": "Debug panel",
	"Deep Backend": "Deep backend",
	"Detail": "Detail",
	"Detail hovoru - časová osa": "Call details – timeline",
	"Detail kampaně": "Campaign detail",
	"Detaily": "Details",
	"Detaily hovoru": "Call detail",
	"Detekována smyčka přesměrování skrze {path}": "Redirect loop detected via {path}",
	"Dialer": "Dialer",
	"Dle volajícího čísla": "By caller number",
	"Dnes": "Today",
	"Dny v týdnu": "Week days",
	"Do": "To",
	"Doba trvání pauzy (s)": "Pause duration (s)",
	"Doba ve frontě": "Queue time",
	"Dobrušská 1794/1\n147 00 Praha 4": "Dobrušská 1794/1\n147 00 Prague 4",
	"Docházka": "Attendance",
	"Dodatečné číslo volajícího": "Additional caller name",
	"Doklad": "Document",
	"Dokončeno": "Completed",
	"Dokončenost": "Finished calls",
	"Dokončit přepojení": "Finish redirect",
	"Dokončit registraci": "Complete registration",
	"Dokumentace": "Documentation",
	"Dokumentace API": "API documentation",
	"Dokumentace nebyla nenalezena.": "Documentation was not found.",
	"Dokumentace pro aplikaci\nBC4 Kontaktní centrum": "BC4 Contact Center Application Documentation",
	"Doména PBX": "PBX Domain",
	"Dostupné adresáře": "Available directories",
	"Dostupné fronty": "Available queues",
	"Dostupné komunikační kanály": "Available communication channels",
	"Dostupné linky": "Available extensions",
	"Dostupné pauzy": "Available pauses",
	"Dostupné záložky": "Available tabs",
	"Dostupné záznamníky": "Available mailboxes",
	"Dostupné časové podmínky": "Available time conditions",
	"Dostupné Šablony": "Available templates",
	"Dostupný": "Available",
	"Dovolané": "Picked up",
	"Dovolaných In": "Answered In",
	"Dovolaných Out": "Answered Out",
	"Druh": "Kind",
	"Druh vozidla": "Vehicle type",
	"Duplicitní": "Duplicit",
	"Dát do pauzy agenta po skončení hovoru": "Pause agent after completing a call",
	"Dát do pauzy agenta, který hovor nepřijal": "Pause agent who did not accept the call",
	"Délka hovoru": "Call duration",
	"Délka pauzy [s]": "Pause duration [s]",
	"Délka pauzy v sekundách": "Pause duration in seconds",
	"Délka vyzvánění": "Ringing duration",
	"Délka záznamu": "Recording duration",
	"Děkujeme za hlášení": "Thank you for the report",
	"Důvod ukončení: ": "End reason: ",
	"E-mail": "Email",
	"E-mailové adresy pro odeslání nových záznamů": "Email addresses to send new records",
	"Editace": "Editing",
	"Edituje agent": "Agents can edit",
	"Edituje supervizor": "Supervisors can edit",
	"Ekonomické stavby": "Economic Buildings",
	"Ekonomické stavby API": "Economic Buildings API",
	"Export": "Export",
	"Export do XLSX": "Export to XLSX",
	"Export kontaktů": "Export contacts",
	"Exportovat CSV pro Mitel": "Export CSV for Mitel",
	"Exportovat XLSX": "Export XLSX",
	"Exportovat XML pro Htek": "Export XML for Htek",
	"Exportovat XML pro Yealink": "Export XML for Yealink",
	"Ext.": "Ext.",
	"Externí": "External",
	"Externí linka": "External extension",
	"Firma": "Company",
	"campaign-case-export|Firma": "Company",
	"Firma posledního volaného": "Last callee's company name",
	"Firma volajícího": "Caller's company name",
	"Firma volaného": "Callee's company name",
	"Followme": "Followme",
	"Followme (přesměrování)": "Followme (redirect)",
	"Freeseating": "Freeseating",
	"Freshdesk": "Freshdesk",
	"Fronta": "Queue",
	"Fronta již existuje.": "Queue already exists.",
	"Fronta skrze kterou volat": "Queue prefix to use",
	"Fronta {queue} nemá přiřazenu skupinu kategorií.": "The queue {queue} does not have a category group assigned.",
	"Frontové požadavky": "Queue requests",
	"Fronty": "Queues",
	"Fronty můžete přidat výběrem z pravého sloupce": "You can add queues by selecting them from the right column",
	"Fronty ve skupině": "Queues in a group",
	"Geco Report API": "Geco Report API",
	"Generovat": "Generate",
	"Generovat hlášku": "Generate a message",
	"Generovat odpoveď hned po připojení": "Generate response immediately after connection",
	"Graf uzavření případů": "Closed cases graph",
	"Graf úspěšnosti": "Success graph",
	"HTTP API URL": "HTTP API URL",
	"HW": "HW",
	"Headsety": "Headsets",
	"Hesla se neshodují": "Passwords do not match",
	"Heslo": "Password",
	"Heslo (číselné)": "Numeric password",
	"Heslo k účtu": "Account password",
	"Heslo musí být zadáno, pokud uživatel ještě neexistuje": "Password must be set if the user does not yet exist",
	"Heslo musí musí být dlouhé alespoň 12 znaků.": "Password needs to be at least 12 characters long.",
	"Heslo pro přihlášení (Prázdné = beze změny)": "Login password (Empty = no change)",
	"Heslo změněno": "Password changed",
	"Historie": "History",
	"Historie front": "Queues history",
	"Historie hovorů ústředny": "PBX call history",
	"Historie hovorů ústředny Mx-One": "Call History PBX Mx-One",
	"Historie volání": "Call history",
	"Historie čísel": "Phone number history",
	"Historie čísla": "Caller history",
	"Hlas": "Voice",
	"Hlasitost": "Volume",
	"Hlasová schránka": "Voicemail",
	"Hlasová schránka {name} neexistuje": "Voicemail {name} does not exist",
	"Hlasové schránky": "Voicemails",
	"Hlavička": "Header",
	"Hlavní kategorie": "Main category",
	"Hledat": "Search",
	"Hledat agenta nebo linku": "Search for agent or extension",
	"Hledat jméno nebo email": "Search for name or email",
	"Hledat jméno, firmu, linku": "Search for name, company, or phone",
	"Hledat jméno, firmu, telefon": "Search name, company, phone",
	"Hledat kampaň": "Search campaign",
	"Hledat komunikační kanál": "Search for communication channel",
	"Hledat komunikační kanály": "Search communication channels",
	"Hledat kontakt": "Search for contact",
	"Hledat linku": "Search extensions",
	"Hledat název": "Search name",
	"Hledat název nebo číslo": "Search for name or number",
	"Hledat název nebo číslo fronty": "Search for name or queue number",
	"Hledat záložku": "Find tab",
	"Hledat záznamník": "Find mailbox",
	"Hledat časovou podmínku": "Search time condition",
	"Hledat časové podmínky": "Search time conditions",
	"Hláška": "Sound message",
	"Hláška po vyzvednutí agentem": "Announcement after agent picks up",
	"Hláška pro volaného při odchozím volání": "Announcement for the callee on outgoing call",
	"Hláška s tónovou volbou": "Sound message with DTMF menu",
	"Hlášky": "Sounds",
	"Hlášky a zvuky": "Sounds and messages",
	"Hodnoceno": "Rated",
	"Hodnocené": "Rated",
	"Hodnocení": "Rating",
	"Hodnocení hovoru": "Call rating",
	"Hodnota je příliš nízká": "Value is too low",
	"Hodnota je příliš vysoká": "Value is too high",
	"Hostitel": "Host",
	"Hotovo": "Done",
	"Hovor": "Call",
	"Hovor bude směrován na agenta pouze pokud bude uskutečněn v rámci tohoto časového okna od posledního vyzvednutí hovoru agentem.": "A call will only be routed to an agent if it occurs within this time window from the last call pickup by the agent.",
	"Hovor byl odmítnut": "Call was rejected",
	"Hovor je přesměrováván, prosím vyčkejte...": "The call is being transfered, please wait...",
	"Hovor nebyl nalezen, nebo k němu nemáte přístup": "Call not found or you do not have access",
	"Hovor nelze momentálně uskutečnit, zkuste to později": "The call cannot be made at the moment, please try later",
	"Hovor neprobíhá v tomto okně prohlížeče.": "The call is not proceeding in this browser window.",
	"Hovor odmítnut": "Call rejected",
	"Hovor přesměrován": "Call redirected",
	"Hovor ukončen": "Call ended",
	"Hovor vypršel, protože nebyl vyzvednut včas": "Call expired because it was not answered on time",
	"Hovor začal": "Call started",
	"Hovory": "Calls",
	"Hovoří": "Speaking",
	"Hovoří v jiné frontě": "Speaking in other queue",
	"Hovoří v této frontě": "Speaking in this queue",
	"Hromadné rozeslání": "Mass sending",
	"Htek": "Htek",
	"Hudba při čekání": "Music on hold",
	"ID": "ID",
	"ID hovoru": "Call ID",
	"ID klienta": "Client ID",
	"ID skupiny": "Group ID",
	"ID zařízení": "Device ID",
	"IP adresa": "IP address",
	"IP adresa (a volitelně port) vzdálené proxy": "IP address (and optional port) of remote proxy",
	"IP adresa SBC": "SBC IP address",
	"IP adresa SIP proxy": "SIP proxy IP address",
	"IP adresa VLOOP pro PBX": "VLOOP IP address for PBX",
	"IP adresa klienta": "Client IP address",
	"IP adresy": "IP addresses",
	"Identifikace místní ústředny": "Local PBX identification",
	"Identifikace příchozích SIP zpráv": "Incoming SIP message identification",
	"Import": "Import",
	"Import se připravuje": "Import is being prepared",
	"Import z XLSX": "Import from XLSX",
	"Importováno {n} záznamů": [
		"",
		""
	],
	"Indikace čekání ve frontě volajícímu": "Queue waiting indication to the caller",
	"Informace": "Information",
	"Instrukce": "Instructions",
	"Interface connector": "Interface connector",
	"app|Interface connector": "Interface connector",
	"Intergrovaná historie zákazníků": "Integrated customer history",
	"Interní": "Internal",
	"Interní linka": "Internal extension",
	"Interní linka nemá nastavenou odchozí identifikaci": "Internal extension is missing outbound identification number",
	"Interní linka nemůže začínat prefixem 99": "Internal extension must not start with number 99",
	"Interní linky": "Internal extensions",
	"Interval automatického opuštění fronty (s)": "Automatic queue exit interval (s)",
	"Interval kontroly doručení zpráv, v sekundách (výchozí: 10)": "Message delivery check interval, in seconds (default: 10)",
	"Interval přehrávání (s)": "Playback interval (s)",
	"Interval volby dalšího agenta (s)": "Next agent selection interval (s)",
	"Intervaly": "Ranges",
	"Intervaly pro správné zobrazení stavů v Agent panelu": "Ranges for agent/call overviews state colors in Agent panel",
	"Jakýkoli jazyk podle ISO-639-1": "Any language according to ISO-639-1",
	"Jazyk": "Language",
	"Je li přihlášený na libovolném zařízení (v agent panelu či HW telefonu)": "When logged in via any device (agent panel or HW phone)",
	"Je li přihlášený v agent panelu": "When logged in via agent panel",
	"Je třeba používat čísla v mezinárodním formátu s + na začátku. Pokud trunk očekává jiný formát čísla, nastavení je nutné provést v záložce \"Mapování čísel\" v nastavení trunku.": "Numbers must be in international format with a leading +. If the trunk expects a different format, configure it in the 'Number Mapping' tab of the trunk settings.",
	"Je třeba vybrat vlastníka fronty. Fronty nebyly přidány do skupiny.": "You must select an owner for the queue. Queues were not added to the group.",
	"Je třeba vybrat vlastníka komunikačního kanálu. Komunikační kanál nebyl přidán do skupiny.": "You must select an owner for the communication channel. The channel was not added to the group.",
	"Je třeba zadat poznámku": "You have to write a note first",
	"Jen svá data - účastník a agent vidí jen svá data, ostatní role vidí data celé skupiny": "Own data only - the participant and agent see only their own data; other roles see the data of the entire group.",
	"Jméno": "Name",
	"campaign-case-export|Jméno": "Name",
	"Jméno kampaně": "Campaign name",
	"Jméno linky": "Extension",
	"Jméno posledního volaného": "Last callee name",
	"Jméno pravidla": "Rule name",
	"Jméno skupiny": "Group name",
	"Jméno trunku": "Trunk name",
	"Jméno volajícího": "Caller name",
	"Jméno volaného": "Callee name",
	"Jméno účtu": "Account name",
	"Jste přihlášeni v těchto forntách": "You are logged into these fronts",
	"K nahrávkám nemáte přístup": "You do not have access to the recordings",
	"K této aplikaci nemáte přístup": "You do not have access to this application",
	"K číslu nebyla nalezena žádná data": "No data found for number",
	"Kampaň": "Campaign",
	"Kampaň byla založena. Naleznete ji v záložce \"Neaktivní.\"": "The campaign has been created. You can find it in the \"Inactive.\"",
	"Kampaň/Kontakt": "Campaign/Contact",
	"Kanál": "Channel",
	"Kanály": "Channels",
	"Karta hovoru": "Call card",
	"Karta kontaktu": "Contact card",
	"Karta zákazníka": "Customer card",
	"Kategorie": "Category",
	"Kategorie 1": "Category 1",
	"Kategorie 2": "Category 2",
	"Kategorie hovorů": "Phone call categories",
	"Kategorii lze změnit jen u frontového hovoru.": "Category can be changed only on a call to a queue.",
	"Kdo ukončil hovor": "Who ended the call",
	"Když je linka obsazena": "When the line is busy",
	"Když na lince není dostupné žádné zařízení": "When there's no registered device on the line",
	"Když není volaný na whitelistu": "If the callee is not on the whitelist",
	"Když ve frontě není přihlášen žádný agent": "When no agent is logged into a queue",
	"Když volaný nevyzvedne hovor": "When the callee does not answer",
	"Když všichni agenti hovoří": "When all agents are busy",
	"Ke směrování bude docjázet pouze u hovorů z veřejné sítě. Hovor musí být uskutečněn na stejné vstupní číslo.": "Routing will only occur for calls from the public network. The call must be made to the same entry number.",
	"Kompaktní zobrazení front": "Compact queues view",
	"Komprimovat nahrávky": "Compress recordings",
	"Komunikační kanál nebyl nalezen": "Communication channel not found",
	"Komunikační kanál nebyl nalezena": "Communication channel not found",
	"Komunikační kanály": "Communication channels",
	"Komunikační kanály a zprávy (SMS a WhatsApp)": "Communication channels and messages (SMS and WhatsApp)",
	"Komunikační kanály můžete přidat výběrem z pravého sloupce": "You can add communication channels by selecting them from the right column",
	"Komunikační kanály ve skupině": "Communication channels in the group",
	"Komunkační kanály": "Communication channels",
	"Kondenzované zobrazení": "Compact view",
	"Konec hovoru": "Call end",
	"Konfigurace je v pořádku": "Configuration is valid",
	"Konfigurace obsahuje chyby, které je nutné před uložením opravit.": "The configuration contains errors that must be corrected before saving.",
	"Konkrétní data": "Individual dates",
	"Konkrétní hodiny": "Individual hours",
	"Kontakt nenalezen": "Contact not found",
	"Kontakt není uložen v adresáři": "The contact is missing from the directory",
	"Kontakt odstraněn": "Contact removed",
	"Kontakt upraven": "Contact modified",
	"Kontakt vytvořen": "Contact created",
	"Kontaktní centrum": "Contact center",
	"Kontakty": "Contacts",
	"Kontakty k importu": "Contacts to import",
	"Kontrola": "Verification",
	"Kontrola nastavení ústředny": "PBX setup verification",
	"Kopírovat odkaz": "Copy link",
	"Kotel": "Boiler",
	"Ladění systému": "System debugging",
	"Lead2Car: selhalo načtení odkazu": "Lead2Car: failed to load link",
	"Limit velikosti obrázku je 10 MiB.": "Image size limit is 10 MiB.",
	"Limit velikosti souboru je 10MB": "Image size limit is 10 MiB",
	"Limit velikosti souboru je 10kB": "File size limit is 10 kB",
	"Limit velikosti souboru je {size} MiB": "File size limit is {size} MiB",
	"Linka": "Extension",
	"Linka / Telefonní číslo": "Extension / Phone number",
	"Linka již existuje.": "Line already exists.",
	"Linka má nastaveno velmi slabé heslo.": "Extension has very weak password.",
	"Linka nenalezena": "Extension not found",
	"Linka sdílí heslo s jinými linkami. Sdílení hesel je nebezpečné.": "This line shares its password with other lines. Password sharing is unsafe.",
	"Linked ID": "Linked ID",
	"Linked Id": "Linked ID",
	"Linky": "Extensions",
	"Linky můžete přidat výběrem z pravého sloupce": "You can add queues by selecting them from the right column",
	"Linky ve skupině": "Extensions in a group",
	"Log události z POST /api/debug/loopback": "Event log from POST /api/debug/loopback",
	"Login": "Login",
	"Logy mobilní aplikace": "Mobile application logs",
	"Logy v časové ose": "Logs in timeline",
	"Lokální číslo": "Local number",
	"Loopback log": "Loopback log",
	"Lze nahrát pouze soubor do velikosti {size} MiB": "Only files up to {size} MiB can be uploaded",
	"Malfini - Wallboard": "Malfini - Wallboard",
	"Malfini Customers API": "Malfini Customers API",
	"Malfini Wallboard": "Malfini Wallboard",
	"Mapování čísel": "Number mapping",
	"Maskováno stejně očíslovanou frontou": "Masked with the same numbered queue",
	"Maskováno stejně očíslovanou hlasovou schránkou": "Masked with the same numbered voicemail",
	"Maskováno stejně očíslovanou interní linkou": "Masked with the same numbered internal line",
	"Maskováno stejně očíslovanou zkrácenou volbou": "Masked with the same numbered speed dial",
	"Maskováno číslem pro přímé vyzvednutí cizí vyzvánějící linky": "Number to pick up a call from any ringing line",
	"Maskováno číslem pro tísňové volání": "Masked with emergency call number",
	"Maskováno číslem pro vyzvednutí cizí vyzvánějící linky v pickup skupině": "Number to pick up a call from another ringing line in a pickup group",
	"Maskováno číslem pro vyzvednutí cizí vyzvánějící linky z libovolné pickup skupiny": "Masked with number to pick up another ringing line from any pickup group",
	"Maskováno čísly pro parkoviště hovorů": "Masked with numbers for call parking",
	"Maximální doba čekání na agenta, před pokračováním do fronty (sekundy)": "Maximum wait time for an agent before continuing into the queue (seconds)",
	"Maximální počet souběžných kanálů": "Maximum number of simultaneous channels",
	"Mazaný objekt nebyl nalezen": "Deleted object not found",
	"MediReha": "MediReha",
	"Metadata": "Metadata",
	"Minulý měsíc": "Last month",
	"Minulý rok": "Last year",
	"Minulý týden": "Last week",
	"Minut": "Minutes",
	"Mluvii": "Mluvii",
	"Model": "Model",
	"Moje otevřené": "My open cases",
	"Moje případy": "My Cases",
	"Moje uzavřené": "My closed cases",
	"Momentálně nelze volat do veřejné sítě (porucha spojení)": "Currently unable to call the public network (connection failure)",
	"Musí být jedno až šestimítné číslo": "Must be a 1-6 digit number",
	"Musí být kratší něž 500 znaků": "Must be shorter than 500 characters",
	"Musí být název existujícího trunku": "Must be the name of an existing trunk",
	"Musí být název existujícího trunku (či prázdné pro interní linky)": "Must be the name of an existing trunk (or empty for internal lines)",
	"Musí být tel. číslo": "Must be a phone number",
	"Musí být telefonní číslo": "Must be a phone number",
	"Musí být telefonní číslo (1-6 číslic)": "Must be a phone number (1–6 digits)",
	"Musí být veřejné číslo v mezinárodním formátu": "Must be a public service phone number in international format",
	"Musí být číslo": "Invalid number",
	"Musí být číslo 0 - 99999": "Must be a number 0–99999",
	"Musí být řetězec 1 - 40 znaků": "Must be a string of 1–40 characters",
	"Musí být řetězec 1 - 60 znaků": "Must be a string with 1 - 60 characters",
	"Musí mít alespoň 5 znaků": "Must be at least 5 characters long",
	"Musí se skládat z 4 až 12 čísel": "Must consist of 4 to 12 digits",
	"Musí se skládat z čísel linek oddělených čárkou": "Must consist of line numbers separated by commas",
	"Mx-One CDR": "Mx-One CDR",
	"Má pauzu": "Paused",
	"Máte podržený hovor": "You have a call on hold",
	"Máte probíhající hovor": "You have a call in progress",
	"Máte příchozí hovor": "You have an incoming call",
	"Méně": "Less",
	"Měsíční report": "Monthly report",
	"Můžete buď stáhnout soubor s kontakty do vašeho počítače, nebo zkopírovat odkaz do telefonu, pro automatickou synchronizaci kontaktů.": "You can either download the contacts file to your computer or copy the link to your phone for automatic contact synchronization.",
	"NAT": "NAT",
	"Na Váš e-mail Vám zašleme odkaz na stránku, kde si budete moci nastavit nové heslo.": "We will send a link to your email where you can set a new password.",
	"Na dané lince/frontě není nikdo zaregistrovaný/přihlášený": "No one is registered/logged in on the given line/queue",
	"Na tuto URL bude zaslán HTTP POST dotaz obsahující informace o hovoru. Hovor bude po přijetí odpovědi směrován podle obsahu odpovědi.": "An HTTP POST request containing call information will be sent to this URL. The call will be routed based on the response content.",
	"Nabídky": "Offers",
	"Nahlásit problém": "Report a problem",
	"Nahradit za číslo": "Replace with number",
	"Nahrání selhalo - neznámá chyba": "Upload failed - unknown error",
	"Nahrání selhalo - vypršel časový limit": "Upload failed - timeout expired",
	"Nahrát": "Upload",
	"Nahrát hlášku": "Upload sound message",
	"Nahrát lze jen jedno foto": "Only one photo can be uploaded",
	"Nahrát lze pouze fotografie": "Only photos can be uploaded",
	"Nahrát obrázek": "Upload image",
	"Nahrát soubor": "Upload a file",
	"Nahrát soubor (.XLSX)": "Upload file (.XLSX)",
	"Nahrát soubor (.gz nebo jakýkoli text)": "Upload a file (.gz or any text)",
	"Nahrát soubor (wav, ogg/vorbis, mp3, ...)": "Upload file (wav, ogg/vorbis, mp3, ...)",
	"Nahrávat hovory, které projdou touto routou": "Record calls passing through this route",
	"Nahrávat všechny hovory, které projdou touto frontou": "Record all calls via this queue",
	"Nahrávat všechny hovory, které projdou touto linkou": "Record all calls with this extensions",
	"Nahrávka nedostupná": "Upload unavailable",
	"Nahrávky": "Recordings",
	"Nahrávky a záznamník": "Recordings and voicemail",
	"Nahrávky přehrávat vždy na webu": "Always play recordings on the web",
	"Nahrávání hovorů": "Call recording",
	"Např. Vedení, Obchod, Reklamace, Servis...": "Eg. Management, Sales, Service department, ...",
	"Nastavena odchozí routa s prefixem": "Otbound prefix route used",
	"Nastavená": "Set",
	"Nastavení": "Settings",
	"Nastavení ChatGPT hlasových profilů": "ChatGPT voice profile settings",
	"Nastavení HW telefonů": "HW phones configuration",
	"Nastavení callflow": "Callflow settings",
	"Nastavení front": "Queue settings",
	"Nastavení linek": "Extensions setup",
	"Nastavení pickup skupin": "Pickup groups settings",
	"Nastavení potlačení ozvěny": "Echo suppression settings",
	"Nastavení sloupců": "Table columns configuration",
	"Nastavení sítě či ústředny není optimální. Sestavení zvukového spojení hovoru může trvat delší dobu či selhávat.": "The network or PBX configuration is suboptimal. Establishing a call audio connection may take longer or fail.",
	"Nastavení vyzvedávacích prefixů": "Pickup prefixes settings",
	"Nastavení vyzváněcího zařízení": "Ringer device configuration",
	"Nastavení záznamníků": "Mailboxes configuration",
	"Nastavení ústředny": "PBX settings",
	"Nastavit WhatsApp": "Setup WhatsApp",
	"Nastavit Whatsapp": "Setup WhatsApp",
	"Nastavit heslo uživatele": "Set user password",
	"Nastavit nové heslo": "Set a new password",
	"Nastavit podle šablony": "Setup from template",
	"Nastavit timeout": "Set timeout",
	"Nastavit vlastní heslo": "Set a custom password",
	"Nastavit vnitřní směrování pro veřejná čísla": "Set internal routing for public numbers",
	"Nastavit výchozí odchozí směrování": "Set default outbound routing",
	"Načíst kartu hovoru": "Load call history",
	"Načíst novou verzi": "Load new version",
	"Načítají se data": "Loading data",
	"Načítám...": "Loading...",
	"Ne": "No",
	"Ne, neuzavírat callback": "No, don't close callback",
	"Neaktivní": "Inactive",
	"users|Neaktivní": "Suspended",
	"Nebo sem soubor přetáhněte": "Or drag the file here",
	"Nebo soubor přetáhněte sem": "Or drag the file here",
	"Nebo vyhledejte požadovanou konverzaci": "Or search for the desired conversation",
	"Nebo začněte novou konverzaci": "Or start a new conversation",
	"Nebyl nalezen žádný záznam": "No record found",
	"Nebyly nalezeny žádné kontakty": "No contacts were found",
	"Nedostupný": "Not available",
	"Nedovolané": "Not answered",
	"Nedovolaných In": "Not answered In",
	"Nedovolaných Out": "Not answered Out",
	"Nedovolit poslednímu přihlášenému agentovi odhlášení": "Prevent the last logged-in agent from logging out",
	"Neděle": "Sunday",
	"Neexistující adresář kontaktů {name}": "Contact directory does not exist: {name}",
	"Neexistující cílová fronta {num}": "Target queue does not exist {num}",
	"Neexistující cílové callflow {name}": "Target callflow does not exist {name}",
	"Neexistující linka {num}": "Extension does not exist {num}",
	"Neexistující zvuková hláška {name}": "Sound message does not exist: {name}",
	"Neexistující Časová podmínka - Call centrum {name}": "Nonexistent time condition - Call center {name}",
	"Neexistující Časová podmínka {name}": "Time condition {name} does not exist",
	"Negativní uzavření": "Negative closure",
	"Negativní zakončení": "Negative closure",
	"Nehodnoceno": "Not rated",
	"Nehodnocené": "Not rated",
	"Nehodnotit": "Do not rate",
	"Nejdelší čas\npropadlého\nhovoru": "Longest\nduration of\nexpired call",
	"Nejpomalejší doba první reakce": "The slowest initial reaction time",
	"Nejpomalejší doba uzavření": "The slowest closure time",
	"Nejprve si vytvořte záložky pro vaše kontakty.": "Create a few tabs for your contacts first.",
	"Nejprve založte skupinu kategorií": "Create a category group first",
	"Nejrychlejší doba první reakce": "The fastest initial reaction time",
	"Nejrychlejší doba uzavření": "The fastest closure time",
	"Nejsou definovány žádné šablony": "No templates available",
	"Nejsou k dispozici žádné záznamníky": "No mailboxes are available",
	"Nejsou k dispozici žádní agenti": "No agents available",
	"Nejsou založeny žádné adresáře": "No directories have been created",
	"Nelze načíst konfiguraci": "Can't load configuration",
	"Nelze změnit skupinu během probíhajícího hovoru": "Cannot change group during an ongoing call",
	"Nelze změnit zařízení pro vyzvánění.": "Cannot change ringing device.",
	"Nelze získat přístup k mediálním zařízením. Aplikace neběží na https, nebo je přístup vypnutý ve vašem prohlížeči.": "Cannot access media devices. The app is not running on HTTPS, or access is disabled in your browser.",
	"Nemá nastaveno žádné zařízení!": "Agent has no device set up!",
	"Nemáte přístup k požadovanému komunikačnímu kanálu": "You do not have access to the requested communication channel",
	"Nemáte přístup k žádným aplikacím": "You have no access to any applications",
	"Nemáte žádné call flow": "No call flow is configured, yet",
	"Nemáte žádné časové podmínky": "No time conditions are configured, yet",
	"Nenastavená": "Unconfigured",
	"Není dostupné žádné zařízení.": "No device available.",
	"Není k dispozici žádné zařízení": "No device available",
	"Není v pořádku!": "Critical!",
	"Neobsahuje nahrávky ani záznamník": "Does not contain recordings or voicemail",
	"Neobsahuje nic": "No details",
	"Neomezená": "Unlimited",
	"Neošetřená výjimka": "Unhandled rejection",
	"Neplatný druh": "Invalid kind",
	"Neplatný formát XLSX, použijte šablonu.": "Invalid XLSX format, use the template.",
	"Nepodporovaný typ": "Unsupported type",
	"Nepodporovaný typ dat": "Unsupported data type",
	"Nepodporovaný typ zprávy, id: {id}": "Unsupported message type, id: {id}",
	"Nepodporovaný uzel": "Unsupported node",
	"Nepovolili jste změnu audio výstupu. Nelze změnit zařízení pro vyzvánění.": "You did not allow changing the audio output. The ringing device cannot be changed.",
	"Nepřečtené": "Unread",
	"Nepřihlášen v této frontě": "Not logged into this queue",
	"Nepřihlášení": "Not logged in",
	"Nepřihlášení agenti": "Logged out agents",
	"Nesmí být prázdné": "Must not be empty",
	"Neuskutečněný": "Not realized",
	"Neuzavřené případy": "Open cases",
	"Nevyzvednutí": "No answer",
	"Nevíte heslo?": "Forgot password?",
	"Nezahájeno": "Not started",
	"Nezahájené": "Not started",
	"Nezměněná": "Not changed",
	"Neznámá chyba": "Unknown error",
	"Neznámá chyba SIP": "Unknown SIP error",
	"Neznámá chyba WebRTC": "Unknown WebRTC error",
	"Neznámá chyba.": "Unknown error.",
	"Neznámé zařízení": "Unknown device",
	"Neznámý důvod (kód: {hangup_cause})": "Unknown reason (code: {hangup_cause})",
	"Neznámý stav přihlášení do fronty": "Unknown queue membership status",
	"Neznámý trunk {name}": "Unknown trunk {name}",
	"Neznámý typ obsahu: ": "Unknown content type: ",
	"Neznámý účet": "Unknown account",
	"Nezpracováno": "Unprocessed",
	"Neúspěch": "Failure",
	"Neúspěšné": "Failure",
	"Nic": "Nothing",
	"Nic neaktualizovat": "Don't update anything",
	"Nic nemazat": "Don't delete anything",
	"Nic nepřidávat": "Don't add anything",
	"Normální zobrazení": "Normal view",
	"Notifikace máte zablokovné v prohlížeči. Nejprve je musíte odblokovat.": "Notifications are blocked in your browser. You must unblock them first.",
	"Notifikace zapnuty": "Notifications enabled",
	"Notifikace zmeškaných hovorů": "Missed calls notifications",
	"Nová": "New",
	"Nová Zpráva": "New message",
	"Nová fronta": "New queue",
	"Nová hláška": "New sound",
	"Nová hromadná zpráva": "New broadcast message",
	"Nová interní linka": "New internal extension",
	"Nová kampaň": "New campaign",
	"Nová pauza": "New pause",
	"Nová poznámka": "New note",
	"Nová routa": "New route",
	"Nová schánka": "New voicemail",
	"Nová skupina": "New group",
	"Nová skupina kategorií": "New category group",
	"Nová volba": "New option",
	"Nová zpráva": "New message",
	"Nová záložka": "New tab",
	"Nová časová podmínka": "New time condition",
	"Nová šablona": "New template",
	"Nové call flow": "New call flow",
	"Nové heslo": "New password",
	"Nové naplánované přihlášení": "New scheduled login",
	"Nové pravidlo": "New rule",
	"Nové číslo": "New number",
	"Nový ChatGPT hlasový profil": "New ChatGPT voice profile",
	"Nový adresář": "New directory",
	"Nový filtr": "New filter",
	"Nový komuninkační kanál": "New communication channel",
	"Nový kontakt": "New contact",
	"Nový transport": "New transport",
	"Nový trunk": "New trunk",
	"Nový uživatel": "New user",
	"Nový záznam": "New entry",
	"Nový člen": "New member",
	"Nyní se můžete přihlásit s použitím Vašeho nového hesla.": "You can now log in using your new password.",
	"Náhrávám": "Recording",
	"Název": "Name",
	"Název aplikace": "Application name",
	"Název fronty": "Queue name",
	"Název kampaně": "Campaign name",
	"Název komunikačního kanálu": "Communication channel name",
	"Název nové kategorie": "New category name",
	"Název časové podmínky": "Time condition name",
	"Některé kontakty se nepodařilo naimportovat. Seznam přeskočených kontaktů je níže. Důvodem je chybné tel. číslo či neplatná emailová adresa. Upravte XLSX soubor a import opakujte.": "Some contacts could not be imported. The list of skipped contacts is below. Reasons include invalid phone numbers or email addresses. Please correct the XLSX file and retry the import.",
	"O aplikaci": "About application",
	"O2 Trunk": "O2 Trunk",
	"OK": "OK",
	"Období": "Period",
	"Obecné": "Basic",
	"Objednávky": "Orders",
	"Obnovit": "Refresh",
	"Obnovit data": "Reload data",
	"Obrázek je vyžadovaný": "Image is required",
	"Obsah zprávy": "Mesage content",
	"Obsahuje kategorii": "Has category assigned",
	"Obsahuje nahrávky": "Has recordings",
	"Obsahuje poznámku": "Has a note",
	"Obsahuje záznamník": "Contains voicemail",
	"Obsazeno": "Busy",
	"Obsazení disků": "Disk utilization",
	"Obsazený": "Busy",
	"Od": "From",
	"Odchod": "Departed",
	"Odchozí": "Outgoing",
	"Odchozí autentizace": "Outgoing authentication",
	"Odchozí filtr": "Outbound filter",
	"Odchozí filtry": "Outbound filters",
	"Odchozí hovory": "Outgoing calls",
	"Odchozí identifikace": "Outbound identification",
	"Odchozí identifikace mezi trunky": "Outgoing identification between trunks",
	"Odchozí identifikace pro odchozí hovory skrze prefix fronty (*9*fronta*volané číslo)": "Outbound identification for outgoing calls using the queue prefix (*9*queue*called number)",
	"Odchozí kampaně": "Outbound campaigns",
	"Odchozí prefix": "Outbound prefix",
	"Odchozí trunk pro veřejná čísla": "Outbound trunk for public numbers",
	"Odchozí volající": "Outgoing caller",
	"Odchozí volaný": "Outgoing callee",
	"Odchozí volby": "Outbound options",
	"Odebrat ze skupiny": "Remove from group",
	"Odeslaná": "Sent",
	"Odeslat": "Send",
	"Odeslat Zprávu": "Send message",
	"Odeslat tuto šablonu?": "Send this template?",
	"Odeslat z": "Send from",
	"Odeslat znovu": "Send again",
	"Odeslat zprávu": "Send message",
	"Odeslat {n} zpráv": "Send {n} messages",
	"Odesílat nové záznamy na e-mail.": "Send new recordings to email.",
	"Odesílat číslo volajícího v hlavičce Remote-Party-ID": "Send the caller number in the Remote-Party-ID header",
	"Odhlásit": "Log out",
	"Odhlásit z front": "Log out of queues",
	"Odhlásit ze všech front": "Logout from all queues",
	"campaign-case-export|Odkaz": "URL",
	"Odkaz byl zaslán": "Link has been sent",
	"Odkaz zkopírován do schránky": "The link was copied to the clipboard",
	"Odložené a zaparkované hovory": "Held and parked calls",
	"Odložený": "In hold",
	"Odložit hovor": "Hold call",
	"Odmítnout": "Reject",
	"Odmítnout hovor": "Reject call",
	"Odmítnuto": "Rejected",
	"Odmítnutý": "Rejected",
	"Odparkováno": "Unparked",
	"Odpojeno": "Disconnected",
	"Odposlech není možný.": "Monitoring is not possible.",
	"Odpovědět": "Reply",
	"Odpověď od AI asistanta není kompletní, generování bylo přeřušeno.": "The response from the AI assistant is incomplete; generation was interrupted.",
	"Odstranit": "Remove",
	"Odstranit audio": "Remove audio",
	"Odstranit mezinárodní předvolbu z českých čísel. U ostatních čísel převést + na 00.": "Remove international prefix from Czech numbers. Convert + to 00 for other numbers.",
	"Odstranit mezinárodní předvolbu z českých čísel. U ostatních čísel převést + na 00. K výsledku předřadit 0": "Remove international prefix from Czech numbers. Convert + to 00 for other numbers and prepend 0.",
	"Odstranit mezinárodní předvolbu ze slovenských čísel. U ostatních čísel převést + na 00.": "Remove international prefix from Slovak numbers. Convert + to 00 for other numbers.",
	"Odstranit obrázek": "Remove image",
	"Odstranit soubor": "Remove file",
	"Odstranit časový rozsah": "Remove time range",
	"Office panel": "Office panel",
	"Offline": "Offline",
	"Ohlašovat volajícímu pořadí ve frontě": "Announce queue position to the caller",
	"Omezená historie fronty": "Limited queues history",
	"Online": "Online",
	"Operátorů\nna příjmu": "Operators on duty",
	"Oportunistické SRTP": "Opportunistic SRTP",
	"Opravdu chcete smazat DTMF volbu {code}?": "Do you really want to delete DTMF menu item {code}?",
	"Opravdu chcete smazat adresář \"{name}\"?": "Are you sure you want to delete the \"{name}\" directory?",
	"Opravdu chcete smazat call flow \"{name}\"?": "Do you really want to delete call flow \"{name}\"?",
	"Opravdu chcete smazat kampaň \"{name}\"?": "Are you sure you want to delete the \"{name}\" campaign?",
	"Opravdu chcete smazat prefixy {pattern}?": "Do you really want to delete prefixes {pattern}?",
	"Opravdu chcete smazat skupinu \"{name}\"?": "Do you really want to delete the group \"{name}\"?",
	"Opravdu chcete smazat skupinu kategorií \"{name}\"?": "Do you really want to delete the category group \"{name}\"?",
	"Opravdu chcete smazat tento uzel?": "Do you really want to delete this node?",
	"Opravdu chcete smazat východ {name}?": "Do you really want to delete exit {name}?",
	"Opravdu chcete smazat časovou podmínku \"{name}\"?": "Do you really want to delete time condition \"{name}\"?",
	"Opravdu si přejete hovor zavěsit?": "Do you really want to hangup the call?",
	"Opravdu smazat aplikaci {name}?": "Are you sure you really want to delete the {name} application?",
	"Opravdu smazat filtr {name}?": "Do you really want to delete filter {name}?",
	"Opravdu smazat frontu {name}?": "Do you really want to delete queue {name}?",
	"Opravdu smazat frontu {num}?": "Do you really want to delete queue {num}?",
	"Opravdu smazat hlášku {name}?": "Do you really want to delete sound {name}?",
	"Opravdu smazat interní linku {num}?": "Do you really want to delete in {num}?",
	"Opravdu smazat komunikační kanál? {name}?": "Do you really want to delete communication channel {name}?",
	"Opravdu smazat kontakt {name}?": "Do you really want to delete the contact \"{name}\"?",
	"Opravdu smazat linku \"{num}\"?": "Do you really want to delete extension \"{num}\"?",
	"Opravdu smazat naplánovanou akci?": "Do you really want to delete the scheduled action?",
	"Opravdu smazat pauzu {name}?": "Are you sure you really want to delete the {name} pause?",
	"Opravdu smazat pravidlo {num}?": "Do you really want to delete rule {num}?",
	"Opravdu smazat routu {num}?": "Do you really want to delete route {num}?",
	"Opravdu smazat schránku {num}?": "Do you really want to delete mailbox {num}?",
	"Opravdu smazat skupinu {name}?": "Do you really want to delete group \"{name}\"?",
	"Opravdu smazat transport {name}?": "Do you really want to delete transport {name}?",
	"Opravdu smazat trunk {name}?": "Do you really want to delete trunk {name}?",
	"Opravdu smazat uživatele {name}?": "Are you sure you really want to delete the user {name}?",
	"Opravdu smazat volbu {num}?": "Do you really want to delete option {num}?",
	"Opravdu smazat všechny naplánované akce?": "Do you really want to delete all scheduled actions?",
	"Opravdu smazat člena \"{num}\"?": "Do you really want to delete member \"{num}\"?",
	"Opravdu smazat číslo \"{num}\"?": "Do you really want to delete number \"{num}\"?",
	"Opravdu smazat číslo {num}?": "Do you really want to delete number {num}?",
	"Opravdu smazat šablonu {name}?": "Do you really want to delete template {name}?",
	"Opravdu smazat?": "Really delete?",
	"Opustit příposlech": "Leave listening",
	"Opuštěno volajícím": "Abandoned by caller",
	"Opuštěné": "Abandoned",
	"Opuštěný": "Abandoned",
	"Originace z ústředny": "PBX origination",
	"Osobní": "Personal",
	"Osobní statistiky": "Personal statistics",
	"Ostatní": "Other",
	"Ostatní nastavení": "Other settings",
	"Ostatní signalizace": "Other signaling",
	"Ostatní uživatelé": "Other users",
	"Otevřít": "Open",
	"Otevřít Lead2Car": "Open Lead2Car",
	"Otevřít v novém okně": "Open in new window",
	"Outbound": "Outbound",
	"Outbound SIP kontakt": "Outbound SIP contact",
	"Outbound SIP proxy": "Outbound SIP proxy",
	"Ovládání HW telefonu": "HW phones control",
	"Ověřovat dostupnost vzdálené SIP proxy": "Check availability of remote SIP proxy",
	"Oznámení": "Notification",
	"Oznámení pro tým": "Team notification",
	"Pauza": "Pause",
	"Pauzy": "Pauses",
	"Pauzy můžete přidat výběrem z pravého sloupce": "You can add pauses by selecting from the right column",
	"Pauzy ve skupině": "Group pauses",
	"Penalta": "Penalty",
	"Penalta agenta": "Agent penalty",
	"Penalta celkem": "Total penalty",
	"Penalta fronty": "Queue penalty",
	"Penalta skupiny": "Group penalty",
	"Permanentní člen fronty {num} neexistuje": "Permanent queue member {num} does not exist",
	"Permanentní členové": "Permanent members",
	"Phone number ID": "Phone number ID",
	"Pickup skupina": "Pickup group",
	"Pickup skupiny": "Pickup groups",
	"Pickup číslo": "Pickup number",
	"Pickup číslo již existuje.": "Pickup number already exists.",
	"Pilotní číslo": "Pilot number",
	"Platforma": "Platform",
	"Plánované": "Scheduled",
	"Plánované přihlašení není validní (fronta není dostupná pro daného agenta)": "Scheduled login is not valid (queue is not available for this agent)",
	"Po opuštění fronty": "After queue exit",
	"Po zapnutí této funkce se na tuto linku dovolají pouze čísla v následujícím seznamu. Funkci lze ovládat vytočením speciálního čísla *75 z této linky. Zjištění stavu je možné vytočením *76.": "When this feature is enabled, only numbers in the following list can call this line. Control the feature by dialing *75 from this line. Check status by dialing *76.",
	"Podkategorie": "Subcategory",
	"singular|Podkategorie": "Subcategory",
	"Podle pořadí": "By order",
	"Podle času": "By time",
	"Podpora pro připojení zařízení za NATem": "Support for contacts behind client side NAT",
	"Podrobná dokumentace k API je součástí dokumentu \"Základní API\", který je k dispozici ke stažení níže.": "Detailed API documentation is included in the 'Basic API' document available for download below.",
	"Podržený hovor": "Call on hold",
	"Podíl": "Ratio",
	"Pohoda": "Pohoda",
	"Pokoušíte se zobrazit více jak {max} hovorů, pro jejich získání použijte export do XLSX, nebo použijte jiný filtr.": "You are trying to display more than {max} calls; use XLSX export or another filter to retrieve them.",
	"Pokoušíte se zobrazit více jak {max} hovorů, pro jejich získání použijte jiný filtr.": "You are trying to display more than {max} calls; use another filter to retrieve them.",
	"Pokračovat do fronty": "Enter into a queue",
	"Pokračovat do fronty a zůstat v ní": "Enter queue and stay in it",
	"Pokročilé": "Advanced",
	"Pokročilé volby": "Advanced settings",
	"Pokud je zaškrtnuté, ChatGPT bude generovat odpoveď ihned po připojení. V opačném případe se čeká na vstup od volajícího.": "If checked, ChatGPT will generate a response immediately after connecting; otherwise it waits for input from the caller.",
	"Pokud potřebujete rozlišit uzel callflow odkud bylo volání HTTP API vyvoláno, můžete si do URL přidat vlastní query parametr, např.: https://moje.api.cz/callflow-router?uzel=vipadresar.": "If you need to distinguish which callflow node triggered the HTTP API call, you can add a custom query parameter to the URL, e.g.: https://moje.api.cz/callflow-router?uzel=vipadresar.",
	"Pokud původní agent nevyzvedne hovor v tomto limitu, bude volající směrován do fronty běžným způsobem.": "If the original agent does not pick up the call within this limit, the caller will be routed to the queue normally.",
	"Pokusů": "Attempts",
	"Položka": "Item",
	"Pondělí": "Monday",
	"Ponechat beze změny": "Keep unchanged",
	"Ponechat pouze poslední 4 čísla. Zbytek zahodit.": "Keep only the last 4 digits. Discard the rest.",
	"Popis": "Description",
	"Popis chyby": "Error description",
	"Popis kampaně": "Campaign description",
	"Popište krátce problém": "Briefly describe the problem",
	"Poskytuje veřejnou telefonní službu": "Provides a public telephone service",
	"Poslat do hlasové schránky linky": "Send to voicemail",
	"Poslech a stažení nahrávek hovorů": "Review and download of call recordings",
	"Poslední DID": "Last DID",
	"Poslední fronta": "Last queue",
	"Poslední hovory": "Recent calls",
	"Poslední volaný": "Last called",
	"Posledních 30 dnů": "Last 30 days",
	"Posledních 7 dnů": "Last 7 days",
	"Posílat DTMF analogově": "Send DTMF analogically",
	"Potenciálně neznámý cíl {num}": "Possibly unknown target {num}",
	"Potlačovat ozvěnu": "Suppress echo",
	"Potvrdit": "Confirm",
	"Potvrdit heslo": "Confirm password",
	"Potvrzovací hláška": "Confirmation message",
	"Pouze pro agenty": "Agents only",
	"Pouze pro přihlášené do fronty.": "Queue members only",
	"Používat SRTP": "Use SRTP",
	"Používat TLS/SRTP": "Use TLS/SRTP",
	"Používat jitter buffer pro interní linky (vylepší kvalitu hovoru na méně kvalitních sítích za cenu zvýšení latence)": "Use jitter buffer for internal lines (improves call quality on lower-quality networks at the cost of increased latency)",
	"Používat zdrojovou adresu příchozích RTP paketů jako cíl odchozích RTP paketů bez ohledu na SIP/SDP signalizaci": "Use the source address of incoming RTP packets as the destination for outgoing RTP packets regardless of SIP/SDP signaling",
	"Používá se výchozí zařízení": "Default device is used",
	"Považovat agenta jako volného ve frontě": "Consider an agent in a queue free",
	"Povoleno": "Allowed",
	"Povolená API": "Allowed API",
	"Povolené linky na přepojení": "Allowed lines for transfer",
	"Povolené prefixy (pokud nevyplníte, budou povolená všechna čísla)": "Allowed prefixes (if not filled, all prefixes will be allowed)",
	"Povolit administrátorem definovaná hesla linek": "Enable custom administrator defined extension passwords",
	"Povolit agentům stahování nahrávek": "Allow agents to download call recordings",
	"Povolit funkci volitelného whitelistu": "Enable optional whitelist function",
	"Povolit možnost registrace více kontkatů": "Allow registrations of multiple contacts at the same time",
	"Povolit ošetření NAT (používat externí adresy)": "Enable NAT handling (use external addresses)",
	"Pozitivní uzavření": "Positive closure",
	"Pozitivní zakončení": "Positive closure",
	"Poznámka": "Note",
	"campaign-case-export|Poznámka": "Note",
	"Poznámka CALL": "Call note",
	"Poznámky": "Notes",
	"Poznámky k hovoru": "Call notes",
	"Pozor": "Warning",
	"Počet dokončených případů": "Number of completed cases",
	"Počet hovorů": "Number of calls",
	"Počet negativních zakončení": "Number of negative closures",
	"Počet nezakončených případů": "Number incomplete cases",
	"Počet pokusů": "Number of attempts",
	"Počet pozitivních zakončení": "Number of positive closures",
	"Počet rozvolaných čísel": "Number of calls",
	"Počet volných agentů": "Number of free agents",
	"Počet vteřin před automatickém přepojení": "Number of seconds before automatic transfer",
	"Počet zavolání": "Number of dials",
	"Počet zmeškání": "Number of misses",
	"Počet znaků": "Number of characters",
	"Počet čekajících hovorů": "Number of waiting calls",
	"Pořadí kontaktů": "Contact order",
	"Požadovaná hláška nebyla nalezena": "Requested template not found",
	"Pravidelně testovat dostupnost kontaktů": "Periodically test contact reachability",
	"Prefix pro vyzvednutí hovoru z konkrétní vyzvánějící linky": "Prefix to pick up a call from a specific ringing line",
	"Prefix {prefix} již je nastavený v jiné větvi": "Prefix {prefix} is already set in another branch",
	"Prefixy volajícího čísla (oddělené čárkou)": "Caller number prefixes (comma-separated)",
	"Priorita": "Priority",
	"Priority": "Priorities",
	"Pro dokončení registrace zadejte své telefonní číslo a nové heslo pro Váš účet: {email}.": "To complete registration, enter your phone number and new password for your account: {email}.",
	"Pro hovor z": "For call from",
	"Pro prefixy": "For prefixes",
	"Pro tísňová volání lze momentálně zvolit pouze jeden trunk.": "Only one trunk can currently be selected for emergency calls.",
	"Probíhající hovor": "Call in progress",
	"Probíhající hovory": "Calls in progress",
	"Probíhající odposlech": "Spying in progress",
	"Probíhá": "Ongoing",
	"Probíhá aplikace nastavení...": "Configuration update is in progress...",
	"Prodloužit autopauzu": "Extend pause",
	"Prohlížeč zablokoval přístup k audio zařízení": "Browser blocked access to audio device",
	"Prohodit s probíhajícím hovorem": "Switch with call in progress",
	"Projekty": "Projects",
	"Propadlé hovory": "Non-handled calls",
	"Prosíme vyplňte formulář správně.": "Please fill the form correctly.",
	"Prosíme vyčkejte": "Please wait",
	"Protokol": "Protocol",
	"Provisioning": "Provisioning",
	"Práva": "Rights",
	"Práva k hovorům": "CDR access rights",
	"Prázdno": "Empty",
	"Prázdný XLSX soubor": "Empty XLSX file",
	"Průběžná hláška": "Repeated sound message",
	"Průměr": "Average",
	"Průměrná doba první reakce": "Average initial reaction time",
	"Průměrná doba uzavření": "Average closure time",
	"Průměrná délka hovoru": "Average call duration",
	"Průměrná délka vyzvánění": "Average ringing time",
	"Průměrné\nvyzvánění": "Average\nringing",
	"Průměrné vyzvánění": "Average ringing time",
	"Průměrný\nhovor": "Average\ncall duration",
	"Průměrný hovor": "Average call",
	"Průměrný čekající\nčas (callback)": "Average waiting\ntime (callback)",
	"Průměrně\nv IVR": "Average\nin IVR",
	"Průměrně v IVR": "Average in IVR",
	"Pátek": "Friday",
	"Píchačky": "Timecards",
	"Před pokračováním": "Before entry",
	"Před přesměrováním": "Before redirect",
	"Před ukončením hovoru": "Before call termination",
	"Před vybranou akcí": "Before selected action",
	"Před vyváněním": "Before ringing",
	"Před zeptáním": "Before asking",
	"Předmět": "Subject",
	"Přehled agentů, front a aktuálních hovorů": "Overview of agents, queues and current calls",
	"Přehrání selhalo": "Playback failed",
	"Přehrát": "Play",
	"Přehrát hlášku": "Play sound message",
	"Přehrávat průběžnou hlášku": "Play repeated sound message",
	"Přehrávat úvodní hlášku": "Play introductory sound message",
	"Přehrávač hlášky": "Sound message player",
	"Přehrává úvodní hlášku": "Plays introductory announcement",
	"Přehrávání nahrávky": "Play recording",
	"Přehrávání vyzváněcího tónu bylo zablokováno Vaším prohlížečem": "Ringing tone playback was blocked by your browser",
	"Přejmenovat kategorii": "Rename category",
	"Překročen limit počtu WebRTC zařízení. Použijte pro volání office panel, který máte právě otevřený v jiné záložce, či prohlížeči.": "WebRTC device limit exceeded. Use the office panel open in another tab or browser for calling.",
	"Přepadová fronta musí mít také zapnutu funkci směrování hovoru přímo na agenta, jinak se vyzvednutí hovoru na přepadové frontě nebude započítávat.": "Overflow queue must also have direct-to-agent routing enabled; otherwise call pickup in the overflow queue will not be counted.",
	"Přepojeno": "Transferred",
	"Přepojeno přes followme": "Transferred via follow-me",
	"Přepojení": "Transfer",
	"Přepojený": "Transfered",
	"Přepojit": "Transfer",
	"Přepojit automaticky po určitém čase": "Automatically transfer after a set time",
	"Přepojit na": "Transfer to",
	"Přepojit na číslo": "Transfer to number",
	"Přepojit s odložením": "Attended transfer",
	"Přepojovaný": "Transfered",
	"Přeskočeno": "Skipped",
	"Přesměrovat hovor na jiný cíl": "Redirect call to another target",
	"Přesměrovat příposlech": "Transfer call listening",
	"Přesměrovat příposlech na číslo": "Transfer call listening to number",
	"Přesměrování": "Redirection",
	"Přesměrování se ukončuje, prosím vyčkejte...": "Call transfer is being terminated, please wait...",
	"Přetáhnout lze pouze jeden soubor": "Only one file can be redirected",
	"Přetáhnout lze pouze jeden soubor.": "Only one file can be uploaded",
	"Přetáhnout lze pouze jednu fotografii.": "Please drag'n'drop just a single photo here.",
	"Přetáhnout sem lze pouze přesně jeden audio soubor.": "Only one audio file can be drag and dropped here.",
	"Převod textu na řeč": "Text to speech covnersion",
	"Převzít a zahájit hovor": "Take and start call",
	"Převést slovenská místní čísla na mezinárodní formát s + na začátku": "Convert Slovak local numbers to international format with + prefix",
	"Převést česká místní čísla na mezinárodní formát s + na začátku": "Convert Czech local numbers to international format with + prefix",
	"Přečteno": "Read",
	"Přečtené": "Read",
	"Při přepínání linky neodhlašovat z front.": "Do not log out from queues when switching line.",
	"Při přesměrování odesílat Diversion hlavičku": "Send Diversion header during redirection",
	"Přidat DTMF volbu": "Add DTMF menu item",
	"Přidat Kategorie": "Add Categories",
	"Přidat Zprávu": "Add message",
	"Přidat adresář": "Add directory",
	"Přidat aplikaci": "Add application",
	"Přidat call flow": "Add call flow",
	"Přidat další časový rozsah": "Add another time range",
	"Přidat datum": "Add date",
	"Přidat do adresáře": "Add to directory",
	"Přidat do skupiny": "Add to group",
	"Přidat hovor": "Add call",
	"Přidat kampaň": "Add campaign",
	"Přidat kontakt": "Add contact",
	"Přidat linku": "Add extension",
	"Přidat plánované přihlášení": "Add scheduled login",
	"Přidat podmínku": "Add condition",
	"Přidat poznámku": "Add note",
	"Přidat poznámku k hovoru": "Add call note",
	"Přidat prefixy": "Add prefixes",
	"Přidat skupinu": "Add group",
	"Přidat skupinu kategorií": "Add category group",
	"Přidat volbu": "Add DTMF menu item",
	"Přidat východ": "Add exit",
	"Přidat zprávu": "Add message",
	"Přidat záložku": "Add tab",
	"Přidat záznam": "Add entry",
	"Přidat číslo": "Add number",
	"Přidáváte do skupiny osobní frontu. Osobní fronty musí mít nastaveny vlastníka. Vyberte jednoho ze stávajícíh členů skupiny.": "You are adding a personal queue to the group. Personal queues must have an owner. Select one of the existing group members.",
	"Přidáváte do skupiny osobní komunikační kanál. Osobní komunikační kanál musí mít nastaven vlastníka. Vyberte jednoho ze stávajícíh členů skupiny.": "You are adding a personal communication channel to the group. Personal channels must have an owner. Select one of the existing group members.",
	"Přihlašovací údaje": "Login credentials",
	"Přihlašovat jako smart agent": "Join as smart agent",
	"Přihlašování": "Login",
	"Přihlašte se bez něj": "Log-in without",
	"Přihlásit": "Log in",
	"Přihlásit do všech front": "Join to all queues",
	"Přihlášen": "Logged in",
	"queue|Přihlášen trvale": "Subscribed permanently",
	"Přihlášen v jiné skupině": "Logged in another group",
	"Přihlášen v této frontě": "Logged into this queue",
	"Přihlášení": "Login",
	"Přihlášení agenti / Všichni agenti": "Joined agents / All agents",
	"Přihlášení selhalo": "Login failed",
	"Přihlášní přes SIP": "Login via SIP",
	"Přijaté": "Accepted",
	"Připojeno": "Connected",
	"Připojená zařízení": "Connected devices",
	"Připojit headset": "Attach headset",
	"Příchod": "Arrived",
	"Příchozí": "Incoming",
	"Příchozí frontové hovory": "Incoming queue calls",
	"Příchozí hovor": "Incoming call",
	"Příchozí hovor od {contact}": "Incoming call from {contact}",
	"Příchozí hovor ve frontě {queue} od {contact}": "Incoming call in queue {queue} from {contact}",
	"Příchozí hovory": "Incoming calls",
	"Příchozí hovory - Úroveň služby": "Incoming calls - Service level",
	"Příchozí odposlech": "Incoming call listening-in",
	"Příchozí volající": "Incoming caller",
	"Příchozí volby": "Incoming options",
	"Příchozí zpráva od {contact}": "Incoming message from {contact}",
	"Příchozí číslo": "Inbound number",
	"Příjemce": "Receiver",
	"Příloha nenalezena": "Attachment not found",
	"Příloha pro report": "Attachment for report",
	"Přímý": "Direct",
	"Případy vs. Hovory": "Cases vs. calls",
	"Příposlech": "Call monitoring active",
	"Příposlech aktivní": "Listening active",
	"Příposlech byl přesměrován": "Call listening-in was transferred",
	"Přístup z externích sítí na UDP/TLS SIP porty (7670/7671) je automaticky zablokován z důvodu použití slabých hesel na interních linkách.": "Access from external networks to UDP/TLS SIP ports (7670/7671) is automatically blocked due to weak passwords on internal lines.",
	"Registrace dokončena": "Registration complete",
	"Registrace místní ústředny": "Local PBX registration",
	"Registrace selhala": "Registration failed",
	"Registrované mobily": "Registered mobile phones",
	"Registrovat místní ústřednu": "Register local PBX",
	"Registrovat se": "Register",
	"Report agentů": "Agents report",
	"Report agentů - Hořovice": "Agents report - Hořovice",
	"Report agentů 2 - Hořovice": "Agents report 2 - Hořovice",
	"Report agentů II": "Agents report II",
	"Report aktivit": "Activities report",
	"Report callbacků": "Callbacks report",
	"Report front": "Queue report",
	"Report front - Hořovice": "Queues report - Hořovice",
	"Report front - LKQ": "Queue report - LKQ",
	"Report front 2 - Hořovice": "Queues report 2 - Hořovice",
	"Report hovorů podle kategorií": "Calls by category report",
	"Report kampaní": "Campaigns report",
	"Report kategorií": "Categories report",
	"Report obsazenosti kanálů trunku": "Trunk channel occupancy report",
	"Report odchozích hovorů": "Outgoing calls report",
	"Report pauz": "Pauses report",
	"Report počtu hovorů": "Call count report",
	"Report vyžaduje zadaný rozsah": "Report requires a specified range",
	"Report ztracených hovorů": "Lost calls report",
	"Reporty": "Reports",
	"Reporty a statistiky kontaktního centra": "Contact center reports and statistics",
	"Reset hesla": "Reset password",
	"Reset hesla již nelze provést. Platnost odkazu vypršela.": "Password reset can no longer be performed. The link has expired.",
	"Resetovat pořadí": "Reset sort order",
	"Rozbalit vše": "Expand all",
	"Rozcestník": "Signpost",
	"Rozsahy datumů": "Date ranges",
	"Roztáhnout okno": "Expand window",
	"Rozumím": "Roger",
	"Rozvolanost": "Numbers called",
	"Rychlost": "Speed",
	"Rychlé volby": "Speed dial",
	"SDP zpráva je prázdná": "SDP message is empty",
	"SIP URI registrátora": "Registrar SIP URI",
	"SIP doména ústředny (v hlavičce From)": "PBX SIP domain (From header)",
	"SIP uživatel ústředny (v hlavičce From)": "PBX SIP user (From header)",
	"SMS": "SMS",
	"SMS brána": "SMS gate",
	"Sampling temperature for the model, limited to [0.6, 1.2]. For audio models a temperature of 0.8 is highly recommended for best performance.“.": "Sampling temperature for the model, limited to [0.6, 1.2]. For audio models, a temperature of 0.8 is recommended for best performance.",
	"Sbalit vše": "Collapse all",
	"Schránka již existuje.": "Mailbox already exists.",
	"Sconto Wallboard": "Sconto Wallboard",
	"Scénář": "Scenario",
	"Scénáře": "Scenarios",
	"Sehhalo SIP spojení k ústředně": "SIP connection to the PBX has been established",
	"Sekund": "Seconds",
	"Selhala registrace odposlouchávacího zařízení": "Channel spy softphone registration failed",
	"Selhalo SIP spojení k ústředně (chyba dialogu)": "Failed SIP connection to PBX (dialog error)",
	"Selhalo SIP spojení, protistrana nodpověděla": "Failed SIP connection, counterparty nod",
	"Selhalo generování audia": "Audio generation failed",
	"Selhalo navázání datového spojení": "Failed to establish data connection",
	"Selhalo navázání datového spojení, nekompatibilní kodek": "Failed to establish data connection, incompatible codec",
	"Selhalo navázání datového spojení, protistrana nepotvrdila vyzvednutí hovoru": "Failed to establish data connection; the other party did not confirm call pickup",
	"Selhalo načtení dat": "Data load failed",
	"Selhalo stažení hlasů": "Voice download failed",
	"Server je dočasně nedostupný, opakujte odeslání později prosím.": "The server is temporarily unavailable, please try sending later.",
	"Server je nedostupný. Momentálně nelze volat.": "Server unavailable. Currently unable to make a call.",
	"Server neposlal přihlašovací údaje k lince": "Server did not send login credentials to the extension",
	"Server odpojen": "Server disconnected",
	"Service\nlevel": "Service level",
	"Service desk ticket byl založen": "Service desk ticket created",
	"Service desk ticket je již založen": "Service desk ticket was already created",
	"Service level": "Service level",
	"Servisní přihlášení": "Service login",
	"Seznam hovorů": "Call list",
	"Seznam povolených linek pro přepojení, oddělené čárkou, s rozsahy. Příklad: \"200,9000-9009\". Prázdné = bez omezení": "List of allowed lines for transfer, comma-separated, with ranges. Example: \"200,9000-9009\". Empty = no restriction",
	"Seznamový": "List",
	"Siť": "Network",
	"Skrýt": "Hide",
	"Skrýt dialer": "Hide dialer",
	"Skrýt dialer (tónová volba)": "Hide dialer (tone dial)",
	"Skrýt statistiky skupiny": "Hide group statistics",
	"Skrýt vše": "Hide all",
	"Skupina": "Group",
	"Skupina/Fronta": "Group/Queue",
	"Skupiny": "Groups",
	"Smazaná": "Deleted",
	"Smazat": "Delete",
	"Smazat vše": "Delete all",
	"Smazáno": "Deleted",
	"Směr": "Direction",
	"Směrovat": "Route",
	"Směrovat do trunku {trunk} na číslo": "Route to trunk {trunk} to number",
	"Směrovat i v případě, že ke spojení s agentem došlo v minulosit po přepadu na jinou frontu": "Route even if the agent was previously connected after failover to another queue",
	"Směrovat interně na číslo": "Route internally to number",
	"Směrovat na callflow": "Route to call flow",
	"Směrovat na frontu": "Route to queue",
	"Směrovat na linku": "Route to extension",
	"Směrovat volajícího přímo na agenta, se kterým mluvil naposledy": "Route caller directly to the agent they last spoke with",
	"Směrování": "Routing",
	"Směrování dle volajícího čísla": "Route by caller number",
	"Směrování pomocí HTTP API": "Routing via HTTP API",
	"Směrování čísel": "Number routing",
	"Sobota": "Saturday",
	"Soubor": "File",
	"Soubor je vyžadovaný": "File is required",
	"Soubor neobsahuje žádné zprávy.": "File contains no messages.",
	"Soubor s nahrávkou již neexistuje": "Recording file doesn't exist anymore",
	"Souhrny nastavení a změn": "Summary of configuration and change history",
	"Spojená linka": "Connected extension",
	"Spojení": "Connection",
	"Spojení hovoru": "Call connection",
	"Spojený": "Connected",
	"Spojovatelka": "Switchboard",
	"Spravovat headsety": "Manage headsets",
	"Správa front": "Queues management",
	"Správa odchozích kampaní": "Manage outbound campaigns",
	"Správa telefonních čísel, front a callflow": "Administration of phone numbers, queues and callflow",
	"Správa uživatelů, skupin a další nastavení systému": "Manage users, groups and other system settings",
	"Správa záložek": "Tab management",
	"Stahování...": "Downloading...",
	"Standardní zavěšení": "Standard hangup",
	"Start": "Beginning",
	"Statistiky": "Statistics",
	"Statistiky hovorů": "Call statistics",
	"Statistiky skupiny": "Group statistics",
	"Stav": "Status",
	"Stažení přílohy selhalo: ": "Attachment download failed: ",
	"Strategie volby agenta": "Agent selection strategy",
	"Stáhnout": "Download",
	"Stáhnout debugovací report": "Download debug report",
	"Stáhnout nahraný soubor": "Download selected file ({count})",
	"Stáhnout vybrané ({count})": "Download selected ({count})",
	"Stáhnout vzor": "Download template",
	"Stáhnout vzor XLSX": "Download XLSX template",
	"Stáhnout vše": "Download all",
	"Stále jste přihlášeni ve frontách": "You are still logged into the queues",
	"Středa": "Wednesday",
	"Super!": "Super!",
	"Superadmin": "Superadmin",
	"Supervizor panel": "Supervisor panel",
	"Světlý motiv": "Light theme",
	"Systém": "System",
	"Systémová": "System",
	"Systémová zpráva z WhatsAppu: \"{body}\"": "System message from WhatsApp: \"{body}\"",
	"Systémový": "System",
	"T-Mobile TLS Trunk": "T-Mobile TLS Trunk",
	"T-Mobile Trunk": "T-Mobile Trunk",
	"TCP": "TCP",
	"TLS": "TLS",
	"TTS není povoleno": "TTS is not enabled",
	"Tajný klíč": "Secret key",
	"Tato akce nelze vzít zpět.": "This action cannot be undone.",
	"Tato fronta již není dostupná": "This queue is no longer available",
	"Tato fronta již není v systému dostupná": "This queue is no longer available",
	"Tato funkcionalita je zakázána": "This functionality is disabled",
	"Tato linka již v seznamu je": "This extension is already in the list",
	"Tato nahrávka již v úložišti není dostupná": "This recording is no longer available in the repository",
	"Tato časová podmínka je použita minimálně v jednom call flow": "This time condition is used in at least one call flow",
	"Tato časová podmínka není použita": "This time condition is not used",
	"Technické problémy s hovory je dobré hlásit do několika minut po skončení problematického hovoru či situace. K hlášení se automaticky připojuje záznam posledních aktivit v aplikaci a ten při pozdním hlášení již nemusí být aktuální.": "It is recommended to report technical call issues within a few minutes after the problematic call or situation. The report automatically includes a log of recent app activities, which may no longer be up-to-date if reported later.",
	"Tel. čísla": "Phone numbers",
	"Tel. číslo": "Phone number",
	"Telefon": "Phone",
	"campaign-case-export|Telefon": "Phone",
	"Telefon 1": "Phone 1",
	"Telefon 2": "Phone 2",
	"Telefon a historie hovorů": "Phone and call history",
	"Telefonní číslo": "Phone number",
	"Telefonní číslo (vstupní)": "Phone number (inbound)",
	"Tento hovor je bez poznámek": "This call has no notes",
	"Tento hovor nemá žádné nahrávky": "This call was not recorded",
	"Tento měsíc": "This month",
	"Tento rok": "This year",
	"Tento token bude zaslán v HTTP hlavičce \"Authorization\"": "This token will be sent in the HTTP 'Authorization' header",
	"Tento transport se váže na stejnou adresu a port jako transport {other}": "This transport is bound to the same address and port as transport {other}",
	"Tento trunk má stejnou identifikační adresu vzdálené proxy jako trunk {other}": "This trunk has the same remote proxy identification address as trunk {other}",
	"Tento týden": "This week",
	"Tester zákaznického API": "Customer API tester",
	"Text": "Text",
	"Text hlášky": "Message text",
	"Text je příliš dlouhý": "Text is too long",
	"Text je příliš krátký": "Text is too short",
	"Text oznámení...": "Notification text...",
	"TextToSpeech": "TextToSpeech",
	"Timeout": "Timeout",
	"Timeout (s)": "Timeout (s)",
	"Timeout pro nevyzvednutí (s)": "Dial timeout (s)",
	"Timeout vytáčení z linky": "Dial timeout",
	"Timeout vytáčení z linky (s)": "Dial timeout (s)",
	"Tmavý motiv": "Dark theme",
	"Toto pole je vyžadované": "This field is required",
	"Toto číslo již je členem fronty": "This number is already a member of a queue",
	"Toto číslo již v seznamu je": "This number is already in the list",
	"Transkripce je volitelná. Zapnutí spotřebuje víc tokenů, ale v historii bude k dispozici textová transkripce zvukového vstupu od ChatGPT": "Transcription is optional. Enabling it consumes more tokens, but a text transcription of the audio input will be available in history from ChatGPT.",
	"Transkripce neprováděna": "Transcription not performed",
	"Transkripce vstupního audia": "Input audio transcription",
	"Transkripce vstupního audia - jazyk": "Input audio transcription - language",
	"Transkripce vstupního audia - model": "Input audio transcription - model",
	"Transkripce vstupního audia - prompt": "Input audio transcription - prompt",
	"Transport": "Transport",
	"Transporty": "Transports",
	"Trendy vstupních čísel": "Inbound number trends",
	"Trunk": "Trunk",
	"Trunk s tímto jménem již existuje.": "A trunk with this name already exists.",
	"Trunky": "Trunks",
	"Trvale přihlášen v této frontě": "Permanently logged into this queue",
	"Trvání": "Duration",
	"Turn detection - eagerness": "Turn detection - eagerness",
	"Turn detection - prefix_padding_ms": "Turn detection - prefix padding (ms)",
	"Turn detection - silence_duration_ms": "Turn detection - silence duration (ms)",
	"Turn detection - threshold": "Turn detection - threshold",
	"Turn detection type": "Turn detection type",
	"Typ": "Type",
	"Tísňová linka": "Emergency line",
	"Tísňová volání": "Emergency calls",
	"Tónová volba": "Tone dial",
	"Tónová volba (DTMF)": "Tone dial (DTMF)",
	"Tělo zprávy": "Message body",
	"U hovoru chybí telefonní číslo": "Phone number missing in call",
	"UDP": "UDP",
	"Událost": "Event",
	"Ukončil hovor: ": "Call ended:",
	"Ukončit hovor": "End call",
	"Ukončit hovor po vyžádaném callbacku": "End call after requested callback",
	"Ukončit náhrávání": "Finish recording",
	"Ukončit práci": "End work",
	"Uložení je možné až po ukončení hovoru": "Saving is possible only after the call ends",
	"Uložit": "Save",
	"Uložit a zavřít": "Save and close",
	"Uložit a zavřít kartu hovoru": "Save and close the call card",
	"Uložit změny": "Save changes",
	"Uložit, odeslat e-mail a zavřít kartu hovoru": "Save, send email, and close call card",
	"Uložit, odeslat report a zavřít kartu hovoru": "Save, send report, and close call card",
	"Umožnit hovory na tísňové linky skrze tento trunk": "Allow calls to emergency lines through this trunk",
	"Upraveno": "Modified",
	"Upravit": "Edit",
	"Upravit ChatGPT hlasový profil": "Edit ChatGPT voice profile",
	"Upravit DTMF volbu": "Edit DTMF menu item",
	"Upravit Zprávu": "Edit message",
	"Upravit adresář": "Edit directory",
	"Upravit aplikaci": "Edit application",
	"Upravit call flow": "Edit call flow",
	"Upravit filtr": "Edit filter",
	"Upravit frontu": "Edit queue",
	"Upravit hlášku": "Edit sound",
	"Upravit interní linku": "Edit extension",
	"Upravit kampaň": "Edit campaign",
	"Upravit komunikační kanál": "Edit communication channel",
	"Upravit kontakt": "Edit contact",
	"Upravit linku": "Edit extension",
	"Upravit naplánované přihlášení": "Edit scheduled login",
	"Upravit nastavení linky": "Extension settings for",
	"Upravit pauzu": "Edit pause",
	"Upravit pravidlo": "Edit rule",
	"Upravit prefixy": "Edit prefixes",
	"Upravit routu": "Edit route",
	"Upravit schránku": "Edit mailbox",
	"Upravit skupinu": "Edit group",
	"Upravit skupinu kategorií": "Edit category group",
	"Upravit směrovací podmínku": "Edit routing condition",
	"Upravit transport": "Edit transport",
	"Upravit trunk": "Edit trunk",
	"Upravit uživatele": "Edit user",
	"Upravit volbu": "Edit option",
	"Upravit východ": "Edit exit",
	"Upravit záložku": "Edit tab",
	"Upravit záznam": "Edit entry",
	"Upravit časovou podmínku": "Edit time condition",
	"Upravit člena": "Edit member",
	"Upravit číslo": "Edit number",
	"Upravit šablonu": "Edit template",
	"Upravovaný objekt nebyl nalezen": "The edited object was not found",
	"User Agent": "User Agent",
	"Uvítací hláška": "Welcome message",
	"Uzavřel": "Closed by",
	"Uzavřené případy": "Closed cases",
	"Uzavření případu zpětného volání (callback)": "The resolution of the callback case",
	"Uzavřít - neuspěšné": "Close - failure",
	"Uzavřít - úspěšné": "Close - success",
	"Uživatel": "User",
	"Uživatel je v jiné skupině než vy": "User belongs to a different group",
	"Uživatel nebyl nalezen": "User not found",
	"Uživatele můžete přidat výběrem z pravého sloupce": "You can add users by selecting them from the right column",
	"Uživatele můžete založit v konfiguraci uživatelů": "You can create users in the user configuration",
	"Uživatelská příručka": "User manual",
	"Uživatelské jméno": "Username",
	"Uživatelský": "User",
	"Uživatelé": "Users",
	"Uživatelé skupiny": "Group users",
	"V Autopauze": "Autopaused",
	"V CDR jen skupinové hovory": "Only group calls in CDR",
	"V XLSX souboru chybí sloupec {name}": "XLSX file is missing a column: {name}",
	"V hovoru": "In call",
	"V hovoru In": "In call In",
	"V hovoru Out": "In call Out",
	"V hovoru celkem": "Total in call",
	"V pauze": "Paused",
	"V pauze {name}": "Paused - {name}",
	"V pořádku": "OK",
	"V prvním řádku XLSX souboru chybí názvy sloupců: {cols}": "The first line of the XLSX file is missing column names: {cols}",
	"V prvním řádku XLSX souboru musí být názvy sloupců: Jméno, Firma, Telefon": "The first row of the XLSX file must contain column names: Name, Company, Phone",
	"V práci": "At work",
	"V rychlých kontaktech je prázdno": "You don't have any speed dial contact lists",
	"V této skupině nejsou žádní agenti": "There are no agents in this group",
	"Varování": "Warning",
	"Vazba": "Binding",
	"Ve frontách celkem": "In all queues",
	"Ve frontě {queue}": "In queue {queue}",
	"Ve skupině je zatím prázdno": "The group is empty for now",
	"Velikost souboru je příliš velká. Maximální velikost souboru, kterou v současné době WhatsApp podporuje: 100 MB. Domluvte se, prosím, se zákazníkem na zaslání souboru menšího než 100 MB.": "The file is too large. The maximum size currently supported by WhatsApp is 100 MB. Please coordinate with the customer to send a file smaller than 100 MB.",
	"Verze aplikace": "Application version",
	"Viditelnost dat": "Data visibility",
	"Virtuální linka již existuje.": "The virtual line already exists",
	"Vlastní": "Custom",
	"Vlastník": "Owner",
	"Vlastník komunikačního kanálu": "Owner of the communication channel",
	"Vlastník osobní fronty": "Personal queue owner",
	"Vlastník osobního komunikačního kanálu musí být zadaný": "Owner of the personal communication channel must be specified",
	"Vlastník osobního komunikačního kanálu musí být členem skupiny": "Owner of the personal communication channel must be a member of a group",
	"Vlastníka lze zadat pouze u osobní komunikačního kanálu": "The owner can only be assigned for a personal communication channel",
	"VoiceBot": "VoiceBot",
	"Volající": "Caller",
	"Volající a volaný": "Caller and callee",
	"Volající číslo": "Caller number",
	"Volané číslo (DID)": "Called number (DID)",
	"Volané číslo neexistuje": "The called number does not exist",
	"Volaného se nepodařilo vytočit": "Failed to call the number",
	"Volaný": "Callee",
	"Volaný není dostupný": "Called number is not available",
	"Volaný není dostupný (porucha spojení)": "The called number is not available (connection failure)",
	"Volaný neodpověděl": "Caller did not answer",
	"Volba": "Option",
	"Volba (0-9, *, #, +)": "Tone dial (0-9, *, #, +)",
	"Volba DTMF": "DTMF digit",
	"Volitelný text sloužící k určení stylu modelu. U modelu whisper-1 je prompt seznam klíčových slov. U modelů gpt-4o-transcribe je prompt libovolný textový řetězec, například „očekávej slova související s technologií“.": "Optional text to define the model’s style. For whisper-1, the prompt is a list of keywords. For gpt-4o-transcribe models, the prompt can be any text string, e.g., 'expect words related to technology'.",
	"Volitelný whitelist": "Optional whitelist",
	"Volný": "Available",
	"Volných agentů": "Free agents",
	"Volných agentů / Agenti na externích linkách": "Free agents / Agents with external extension",
	"Volných {percent}": "Available {percent}",
	"Voláno na:": "Called number:",
	"Volání API selhalo": "API call has failed",
	"Volání na toto číslo je administrativně blokováno": "Calling this number is administratively blocked",
	"Vráceno z:": "Returned from:",
	"Vrácený hovor": "Returned call",
	"Vrátit do neaktivních": "Return to inactive",
	"Vrátit do probíhajícího hovoru": "Unhold this call",
	"Vrátit výchozí nastavení": "Revert to default settings",
	"Vstup do fronty": "Enter queue",
	"Vstup do ústředny": "PBX entry",
	"Vstupní akce": "Inbound action",
	"Vstupní fronta": "Inbound queue",
	"Vstupní trunk": "Inbound trunk",
	"Vstupní číslo": "Inbound number",
	"Vyber agenta": "Select agent",
	"Vyber si frontu": "Select queue",
	"Vyberte": "Select",
	"Vyberte adresář": "Select directory",
	"Vyberte call flow": "Select call flow",
	"Vyberte cílovou frontu": "Select destination queue",
	"Vyberte cílovou linku": "Select destination extension",
	"Vyberte cílové call flow": "Select destination call flow",
	"Vyberte filtr ze seznamu": "Select filter from the list",
	"Vyberte frontu": "Select a queue",
	"Vyberte frontu ze seznamu": "Select queue from the list",
	"Vyberte hlasovou schránku": "Select a voicemail",
	"Vyberte hlasový profil": "Select a voice profile",
	"Vyberte hlášku": "Select sound message",
	"Vyberte hlášku ze seznamu": "Select sound from the list",
	"Vyberte hodnotu": "Select value",
	"Vyberte kategorii": "Select category",
	"Vyberte kategorii vlevo": "Select category on the left",
	"Vyberte komunikační kanál ze seznamu": "Select a communication channel from the list",
	"Vyberte kontakt ze seznamu": "Select contact from the list",
	"Vyberte linku": "Select extension",
	"Vyberte linku ze seznamu": "Select extension from the list",
	"Vyberte linku...": "Select extension...",
	"Vyberte metodu": "Select a method",
	"Vyberte pauzu ze seznamu": "Select pause from the list",
	"Vyberte podkategorii": "Select subcategory",
	"Vyberte podmínku": "Select a condition",
	"Vyberte položku ze seznamu": "Select an item from the list",
	"Vyberte pravidlo ze seznamu": "Select a rule from the list",
	"Vyberte profil ze seznamu": "Select a profile from the list",
	"Vyberte routu ze seznamu": "Select a route from the list",
	"Vyberte schránku ze seznamu": "Select a mailbox from the list",
	"Vyberte scénář": "Select scenario",
	"Vyberte skupinu ze seznamu": "Select a group from the list",
	"Vyberte telefonní číslo": "Select a phone number",
	"Vyberte transport": "Select a transport",
	"Vyberte transport ze seznamu": "Select a transport from the list",
	"Vyberte trunk": "Select a trunk",
	"Vyberte trunk ze seznamu": "Select a trunk from the list",
	"Vyberte uživatele": "Select a user",
	"Vyberte uživatele ze seznamu": "Select user from the list",
	"Vyberte volbu ze seznamu": "Select an option from the list",
	"Vyberte z voleb": "Select from the list",
	"Vyberte zdroj": "Select a source",
	"Vyberte ze seznamu": "Select from the list",
	"Vyberte záznamník ze seznamu": "Select a mailbox from the list",
	"Vyberte časovou podmínku": "Select a time condition",
	"Vyberte číslo": "Select a number",
	"Vyberte číslo ze seznamu": "Select number from the list",
	"Vyberte šablonu ze seznamu": "Select a template from the list",
	"Vyberte...": "Select...",
	"Vybrat jiné zařízení": "Picked up on another device",
	"Vybrat kategorii": "Select category",
	"Vybrat kategorii a přidat poznámku": "Select category and add a note",
	"Vybrat vše": "Select all",
	"Vybráno *{n} adresářů*": [
		"Selected *{n} directory*",
		"Selected *{n} directories*"
	],
	"Vybráno *{n} front*": [
		"Selected *{n} queue*",
		"Selected *{n} queues*"
	],
	"Vybráno *{n} komunikačních kanálů*": [
		"",
		""
	],
	"Vybráno *{n} linek*": [
		"Selected *{n} extension*",
		"Selected *{n} extensions*"
	],
	"Vybráno *{n} pauz*": [
		"Selected *{n} pause*",
		"Selected *{n} pauses*"
	],
	"Vybráno *{n} položek*": [
		"Selected *{n} item*",
		"Selected *{n} items*"
	],
	"Vybráno *{n} uživatelů*": [
		"Selected *{n} user*",
		"Selected *{n} users*"
	],
	"Vybráno *{n} záložek*": [
		"Selected *{n} tab*",
		"Selected *{n} tabs*"
	],
	"Vybráno *{n} záznamníků*": [
		"Selected *{n} mailboxe*",
		"Selected *{n} mailboxes*"
	],
	"Vybráno *{n} časových podmínek*": [
		"",
		""
	],
	"Vybráno *{n} šablon*": [
		"Selected *{n} template*",
		"Selected *{n} templates*"
	],
	"Vygenerovat": "Generate",
	"Vygenerovat nové heslo": "Generate a new password",
	"Vyhledat v časové ose...": "Search in the timeline...",
	"Vyhledat...": "Search...",
	"Vyhledejte telefonní číslo, které vás zajímá": "Search for a phone number of interest",
	"Vyhledejte telefonní číslo...": "Search a phone number...",
	"Vyhledávání...": "Searching...",
	"Vynutit hodnotu v hlavičce P-Asserted-Identity": "Force value in P-Asserted-Identity header",
	"Vynutit hodnotu v hlavičce P-Preferred-Identity": "Force value in P-Preferred-Identity header",
	"Vynutit konkrétního uživatele SIP URI v Contact hlavičce odchozích SIP zpráv": "Force a specific SIP URI user in the Contact header of outgoing SIP messages",
	"Vypnout mikrofon": "Turn off microphone",
	"Vypnout vyzvánění": "Turn off ringing",
	"Vytočením tohoto prefixu doplněného o číslo linky dojde k vyzvednutí vyzvánějícího hovoru z vybrané linky ve skupině. Vyzvednout lze pouze hovor z jiné linky ve skupině sdílené s vytáčející linkou.": "Dialing this prefix followed by the extension number will pick up the ringing call from the selected line in the group. Only a call from another line in the group shared with the dialing line can be picked up.",
	"Vytočením tohoto čísla dojde k vyzvednutí nejdéle vyzvánějícího hovoru z libovolné linky v libovolné skupině která je sdílená s vytáčející linkou.": "Dialing this number will pick up the longest-ringing call from any line in any group shared with the dialing line.",
	"Vytočením tohoto čísla dojde k vyzvednutí vyzvánějícího hovoru z libovolné linky ve skupině. Vytáčející linka musí být členem skupiny.": "Dialing this number will pick up a ringing call from any line in the group. The dialing line must be a member of the group.",
	"Vytočit": "Dial",
	"Vytočit číslo": "Dial number",
	"Vytvořeno": "Created",
	"Vytvořit": "Create",
	"Vytvořit ": "Create",
	"Vytáčení": "Dialing",
	"Vytáčený hovor": "Dialed call",
	"Vytáčím": "Dial",
	"Vytáčíte nový hovor": "You're dialing a new call",
	"Vyzvedl": "Dialed",
	"Vyzvání": "Ringing",
	"Vyzvánění": "Ringinging",
	"Vyzvánět": "Ringing",
	"Vyřizuje": "Handled by",
	"Vyřídil": "Handled by",
	"Vyřízeno": "Completed",
	"Vyřízené hovory": "Completed calls",
	"Vyžadovat heslo i pro vlasníka linky": "Require a password for the line owner as well",
	"Vyžadováno oprávnění administrátora ústředny": "Only PBX administrator can perform this action",
	"Vyžádaný callback": "Requested callback",
	"Vzdalené číslo": "Remote number",
	"Vzhled": "Appearance",
	"Vznikl": "First time",
	"Váš e-mail": "Your email",
	"Váš účet byl deaktivován": "Your account has been deactivated.",
	"Více": "More",
	"Více agentů": "Multiple agents",
	"Více možností": "More options",
	"Výchozí": "Default",
	"Výchozí číslo odchozí identifikace": "Default outbound caller ID",
	"Výrazné zobrazení front": "Accented queue display",
	"Výskyt": "Appearance",
	"Výsledek": "Result",
	"Výsledek hovoru": "Call result",
	"Výstup": "Exit",
	"Výstupní trunk": "Outbound trunk",
	"Výška hlasu": "Pitch",
	"Včera": "Yesterday",
	"Vše": "All",
	"Vše ostatní": "All others",
	"Všechny": "All",
	"Všechny fronty": "All queues",
	"Všechny kategorie": "All categories",
	"Všechny linky": "All lines",
	"Všechny otevřené": "Open cases",
	"Všechny případy": "All cases",
	"Všechny skupiny": "All groups",
	"Všechny uzavřené": "Closed cases",
	"Všichni": "Everyone",
	"Všichni agenti": "All agents",
	"Všichni agenti hovoří": "All agents are busy",
	"Wallboard": "Wallboard",
	"WebPhone": "WebPhone",
	"Webhook URL: ": "Webhook URL: ",
	"WhatsApp úspěšně nastaven, přidáno telefonních čísel: {added}, aktualizováno telefonních čísel: {updated}": "WhatsApp successfully configured. Added phone numbers: {added}, updated phone numbers: {updated}",
	"Work in progress": "Work in progress",
	"Yealink": "Yealink",
	"Zadanému filtru neodpovídá žádná fronta": "No queue matches the filter",
	"Zadanému filtru neodpovídá žádný agent": "No agent matches the filter",
	"Zadaný komunikační kanál není v této skupině": "The specified communication channel is not in this group.",
	"Zadejte nové heslo pro váš účet: {email}.": "Enter a new password for your account: {email}.",
	"Zadejte telefonní číslo": "Enter a phone number",
	"Zadání kategorie": "Call category selection",
	"Zadání poznámky": "Call notes entry",
	"Zahájit práci": "Start work",
	"Zahájit příposlech": "Start listening",
	"Zakázali jste změnu audio výstupu v prohlížeči. Nelze změnit zařízení pro vyzvánění.": "You have disabled changing the audio output in the browser. The ringing device cannot be changed.",
	"Zakázané prefixy": "Forbidden prefixes",
	"Založit ticket": "Create ticket",
	"Zaparkovat": "Park",
	"Zaparkovat hovor": "Park the call",
	"Zaparkováno": "Parked",
	"Zapauzovat": "Pause",
	"Zapnout mikrofon": "Turn on microphone",
	"Zapnout neomezenou autopauzu": "Turn on unlimited auto-pause",
	"Zapnout notifikace": "Enable notifications",
	"Zapnout pauzu": "Turn on pause",
	"Zapnout vyzvánění": "Turn on ringing",
	"Zaslat odkaz": "Send link",
	"Zatím nejsou vytvořeny žádné skupiny": "No groups are created, yet",
	"Zatím nemáte žádnou skupinu kategorií": "You do not have any category groups, yet",
	"Zatím nemáte žádné rychlé volby": "You have no speed dial shortcuts, yet",
	"Zatím nemáte žádný adresář": "You have no directory yet",
	"Zavolat zpět na linku při selhání přepojení": "Call back the line if transfer fails",
	"Zavolání": "Call count",
	"Zavěsit": "Hang up",
	"Zavřít": "Close",
	"Začátek hovoru": "Start call",
	"Začátek vytáčení": "Start dialing",
	"Začátek vytáčení (vstup do ústředny)": "Start dialing (PBX entry)",
	"Začátek zvonění": "Start ringing",
	"Začátek záznamu": "Begin recording",
	"Zařízení": "Device",
	"Zbývající transkripce nezpracována": "Remaining transcription not processed",
	"Zdroj": "Source",
	"Zeptat se volajícího na číslo": "Ask the caller for a number",
	"Zeptat se volajícího na číslo linky": "Ask the caller for an extension",
	"Zjišťuje se odkaz...": "Checking the link...",
	"Zkontrolovat": "Verify",
	"Zkontrolujte si poštu (včetně spamu) a nastavte si nové heslo pomocí odkazu ve zprávě, kterou jsme Vám zaslali.": "Check your email (including spam) and set a new password using the link in the message we sent you.",
	"Zkopírovat do schránky": "Copy to clipboard",
	"Zkopírovat nastavení do ostatních povolených dnů": "Copy configured time ranges into other enabled days",
	"Zkrácená volba": "Shortcut",
	"Zkrácené volby": "Shortcuts",
	"Zkrácené volby (virtuální linky)": "Shortcuts (virtual extensions)",
	"Zmeškané": "Missed",
	"Zmeškané hovory": "Missed calls",
	"Zmeškané případy": "Missed cases",
	"Zmeškané v IVR": "Missed in IVR",
	"Zmeškaný": "Missed",
	"Zmeškaný hovor": "Missed call",
	"Zmeškaný hovor od {contact}": "Missed call from {contact}",
	"Zmeškaný hovor v IVR od {contact}": "Missed IVR call from {contact}",
	"Zmeškaný hovor ve frontě {queue} od {contact}": "Missed call in queue {queue} from {contact}",
	"Změnit + na začátku na 00": "Change + at the beginning to 00",
	"Změnit heslo": "Change password",
	"Změnit jazyk": "Change language",
	"Změnit jazyk na": "Change language to",
	"Změnit kategorii": "Change category",
	"Změnit pořadí": "Change sort order",
	"Změněná": "Changed",
	"Znak '{char}' není možné odeslat v SMS zprávě": "Character '{char}' is not allowed in a SMS message",
	"Znovu odeslat": "Resend",
	"Zobrazení sloupců": "Columns visibility",
	"Zobrazit": "View",
	"Zobrazit ACL": "View ACL",
	"Zobrazit Kategorie": "Show Categories",
	"Zobrazit Volané číslo (DID) v dialeru": "Show dialed number (DID) in dialer",
	"Zobrazit aktivitu": "Show activity",
	"Zobrazit detail": "Show detail",
	"Zobrazit dialer": "Show dialer",
	"Zobrazit dialer (tónová volba)": "Show dialer (tone dial)",
	"Zobrazit jen poznámky": "Show notes only",
	"Zobrazit kontakty": "View contacts",
	"Zobrazit nahrávku ze záznamníku": "Show mailbox recording",
	"Zobrazit nahrávky": "Show recordings",
	"Zobrazit nahrávky agentům": "Show recordings to agents",
	"Zobrazit nahrávky callbacku": "Show callback recordings",
	"Zobrazit nahrávky ze záznamníku": "Show mailbox recordings",
	"Zobrazit názvy front": "Show queue names",
	"Zobrazit odfiltrované": "Show filtered",
	"Zobrazit po ukončení hovoru okno pro": "When a call ends show window for",
	"Zobrazit poznámku z adresáře při příchozím hovoru": "Show address book note on incoming call",
	"Zobrazit poznámky": "Show notes",
	"Zobrazit přepis hovoru": "Show call transcript",
	"Zobrazit v dialeru fronty jako projekty.": "Show queues as projects in dialer.",
	"Zobrazit v dialeru osobní fronty jako projekty.": "Show personal queues as projects in dialer.",
	"Zobrazit vše": "Show all",
	"Zobrazit zmeškané hovory z IVR": "Show missed IVR calls",
	"Zobrazit časovou osu hovoru": "Show call timeline",
	"Zobrazit čísla front": "Show queue numbers",
	"Zobrazovat přihlášené fronty jako první": "Show joined queues first",
	"Zobrazuje se pouze prvních 200 záznamů. Použijte vyhledávání či export pro práci se všemi záznamy.": "Only the first 200 records are displayed. Use search or export to work with all records.",
	"Zobrazuje se {n} z {total} záznamů. Zobrazení dalších záznamů může trvat dlouhou dobu a výrazně zpomalit prohlížeč.": "Showing {n} of {total} records. Loading more records may take a long time and significantly slow down the browser.",
	"Zpráva": "Message",
	"Zpráva byla přehrána pouze z": "Message was played only from",
	"Zpráva doručena": "Message delivered",
	"Zpráva doručena a přečtena": "Message delivered and read",
	"Zpráva musí obsahovat text, alespoň jednu přílohu, nebo specifikaci šablony": "The message must contain text, at least one attachment, or a template specification",
	"Zpráva nenalezena": "Message not found",
	"Zpráva předána k odeslání": "Message queued for sending",
	"Zpráva se odesílá": "Message is being sent",
	"Zprávu se nepodařilo odeslat. Od poslední odpovědi příjemce na číslo odesílatele uplynulo více než 24 hodin.": "The message could not be sent. More than 24 hours have passed since the recipient's last reply to the sender's number.",
	"Zprávy": "Messages",
	"Zprávy předány k odeslání": "Messages queued for sending",
	"Zpět": "Back",
	"Zrušeno ústřednou (bez odpovědi)": "Canceled by PBX (no answer)",
	"Zrušit": "Cancel",
	"Zrušit autopauzu": "Cancel pause",
	"Zrušit filtry": "Cancel filters",
	"Zrušit odložení": "Cancel hold",
	"Zrušit pauzu": "Cancel pause",
	"Zrušit přepojení": "Cancel reconnect",
	"Zrušit roztažení": "Cancel expansion",
	"Zrušit vynucenou pauzu": "Cancel forced auto-pause",
	"Zrušit výběr": "Deselect all",
	"Ztratíte přístup k administraci skupiny. Pokračovat?": "You are going to lose access to this group. Continue?",
	"Zvednuto na jiném zařízení": "Picked up on another device",
	"Zvednuto pomocí \"pickup\" funkce na jiné lince": "Picked up using 'pickup' function on another line",
	"Zvolte výsledek hovoru": "Classify the call result",
	"Zvoní agent s nejméně hovory": "Agent with the fewest calls is ringing",
	"Zvoní agent, který byl nejdéle bez hovoru": "Rings the agent who has been idle the longest",
	"Zvoní jeden po druhém od posledního": "Ringing one after the other from the last",
	"Zvoní jeden po druhém od prvního": "Ringing one after the other from the first",
	"Zvoní náhodně zvolený agent": "Randomly selected agent is ringing",
	"Zvoní náhodně zvolený agent (váženě podle penalty agenta)": "Rings a randomly selected agent (weighted by agent penalty)",
	"Zvoní všichni najednou": "Ringing all at once",
	"Zvonění In": "Riging In",
	"Základní API": "Basic API",
	"Základní volby": "Basic options",
	"Zálohován trunkem": "Backed up by trunk",
	"Záložka": "Tab",
	"Záložky AP": "AP tabs",
	"Záložky můžete přidat výběrem z pravého sloupce": "You can add tabs by selecting them from the right column",
	"Záložky ve skupině": "Tabs in a group",
	"Záložní trunk musí mít identické vlastnosti směrování hovorů!": "Backup trunk must have identical call routing properties!",
	"Záznam": "Recording",
	"Záznam konverzace s ChatGPT": "ChatGPT conversation recording",
	"Záznam nedostupný": "Record is not available",
	"Záznam není dostupný": "Recording is not available",
	"Záznamník": "Mailbox",
	"Záznamník u callbacku": "Callback mailbox",
	"Záznamník u hovoru": "Call mailbox",
	"Záznamníky": "Mailboxes",
	"Záznamníky můžete přidat výběrem z pravého sloupce": "You can add mailboxes by selecting them from the right column",
	"Záznamníky ve skupině": "Mailboxes in a group",
	"Záznamíky": "Mailboxes",
	"Zůstat ve frontách": "Stay in queues",
	"anonym": "anonymous",
	"timerange|až": "to",
	"bez omezení": "no limit",
	"dd.mm.[rrrr]": "dd.mm.[yyyy]",
	"timerange placeholder|hh": "hh",
	"info@businesscom.cz": "info@businesscom.cz",
	"timerange placeholder|mm": "mm",
	"např. +420123456789": "e.g. +420123456789",
	"např. +420123456798": "eg. +420123456789",
	"např. 0.0.0.0:5060": "e.g. 0.0.0.0:5060",
	"např. 1": "eg. 1",
	"např. 10.10.1.4": "e.g. 10.10.1.4",
	"např. 11.22.33.44": "e.g. 11.22.33.44",
	"např. 11.22.33.44:5060": "e.g. 11.22.33.44:5060",
	"např. 123": "e.g. 123",
	"např. 123456789": "e.g. 123456789",
	"např. 194.108.199.97": "e.g. 194.108.199.97",
	"např. 420123456789": "e.g. 420123456789",
	"např. 420123456789@domena.cz": "e.g. 420123456789@domain.com",
	"např. 60": "eg. 60",
	"např. exit1": "e.g. exit1",
	"např. pbx.bc4cloud.com": "e.g. pbx.bc4cloud.com",
	"např. sip:+420123456789@11.22.33.44": "e.g. sip:+420123456789@11.22.33.44",
	"např. sip:11.22.33.44": "e.g. sip:11.22.33.44",
	"např. sip:11.22.33.44:5061;transport=tls": "e.g. sip:11.22.33.44:5061;transport=tls",
	"např. sip:trunk.cz": "e.g. sip:trunk.cz",
	"např. ustredna.cz": "e.g. ustredna.cz",
	"osobní": "personal",
	"právě teď": "right now",
	"temperature": "temperature",
	"upravit": "edit",
	"www.businesscom.cz": "www.businesscom.cz",
	"zavřít": "close",
	"zobrazit zbytek": "show all",
	"{group}\nplnění": "{group}\nfulfillment",
	"{n} záznamů se importovat nepodařilo": [
		"",
		""
	],
	"Úplná historie hovorů ústředny": "Complete call history of the call center",
	"Úprava kontaktu": "Edit contact",
	"Úroveň In": "Service level In",
	"Úroveň Out": "Service level Out",
	"Úroveň služby": "Service level",
	"Úspešnost dovolání": "Pick up success rate",
	"Úspěch": "Success",
	"Úspěšné": "Success",
	"Úspěšně provedeno": "Successfully completed",
	"Úterý": "Tuesday",
	"Úvodní hláška": "Introductory sound message",
	"ČZU Tickets": "CZU Tickets",
	"Čas": "Time",
	"Čas (začátek intervalu)": "Time (interval start)",
	"Čas dodání plánovaný": "Planned delivery time",
	"Čas posledního odhlášení": "Time of last logout",
	"Čas posledního pokusu": "Time of last attempt",
	"Čas posledního volání": "Time of last call",
	"Čas prvního přihlášení": "Time of first login",
	"Čas registrace": "Time of registration",
	"Čas ukončení": "End time",
	"Čas uzavření": "Closed at",
	"Čas v IVR": "Time in IVR",
	"Čas vyřízení": "Handling time",
	"Čas zahájení": "Start time",
	"Čas založení": "Establishment time",
	"Čas zmeškaného hovoru": "Missed call time",
	"Čas záznamu": "Time of recording",
	"Časová podmínka": "Time range",
	"Časová podmínka - Call centrum": "Time condition - Call center",
	"Časová podmínka je prázdná a nikdy se neuplatní": "Time condition is empty and will never match",
	"Časové podmínky": "Time ranges",
	"Časové podmínky můžete přidat výběrem z pravého sloupce": "You can add time conditions by selecting from the right column",
	"Časové podmínky ve skupině": "Time conditions in group",
	"Časový limit pro směrování na posledního agenta (minuty)": "Time limit for routing to the last agent (minutes)",
	"Časový slot": "Time slot",
	"campaign-case-export|Časový slot do": "Time slot until",
	"campaign-case-export|Časový slot od": "Time slot since",
	"Čekající": "Pending",
	"Čekající hovory": "Call waiting",
	"Čekající čas\nvšech příchozích\nhovorů (bez IVR)": "Waiting time\nfor all incoming\ncalls (excluding IVR)",
	"Čekajících hovorů": "Calls waiting",
	"Čeština": "Czech",
	"Člen nenalezen": "Member not found",
	"Čtvrtek": "Thursday",
	"Čísla pro odchozí identifikaci": "Outbound identification numbers",
	"Číslo": "Number",
	"Číslo (libovolné)": "Number (any)",
	"Číslo fronty": "Queue number",
	"Číslo identifikace pro interní hovory {num} není platným číslem v ústředně": "Identification number for internal calls {num} is not valid in PBX",
	"Číslo je v adresáři": "The number is in the directory",
	"Číslo již existuje.": "Number already exists.",
	"Číslo linky": "Extension number",
	"Číslo musí být vyplněno": "Number must be filled in",
	"Číslo nemá historii": "The phone number has no history",
	"Číslo nenalezeno": "Number not found",
	"Číslo odchozí identifikace {num} není v seznamu telefoních čísel": "Caller identification number {num} is not in the trunk numbers list",
	"Číslo odesílatele": "Sender number",
	"Číslo pro vyzvednutí hovoru z libovolné vyzvánějící linky": "Number to pick up a call from any ringing line",
	"Číslo smlouvy": "Contract number",
	"Číslo v adresáři?": "Number in a directory?",
	"čas": "time",
	"Řadit podle názvu front": "Sort by queue name",
	"Řadit podle čísla front": "Sort by queue number",
	"Šablona nebyla nalezena": "Template not found",
	"Šablona není v této skupině": "Template is not in this group",
	"Šablony": "Templates",
	"Šablony můžete přidat výběrem z pravého sloupce": "You can add templates by selecting from the right column",
	"Šablony pro komunikační kanály": "Templates for communication channels",
	"Šablony ve skupině": "Templates in group",
	"Špatné": "Bad",
	"Žádná": "None",
	"Žádná akce": "No action",
	"Žádná data nejsou k dispozici": "No data available",
	"Žádná hláška": "No announcement",
	"Žádná linka": "No extension",
	"Žádná záloha": "No backup",
	"Žádné aktivní objednávky.": "No active orders.",
	"Žádné audio výstupy nebyly nalezeny": "No audio outputs were found",
	"Žádné další adresáře nejsou dostupné": "No other directories are available",
	"Žádné další fronty nejsou dostupné": "No other queues are available",
	"Žádné další komunikační kanály nejsou dostupné": "No additional communication channels available",
	"Žádné další linky nejsou dostupné": "No other extensions are available",
	"Žádné další pauzy nejsou dostupné": "No more pauses available",
	"Žádné další záložky nejsou dostupné": "No other tabs are available",
	"Žádné další záznamníky nejsou dostupné": "No other mailboxes are available",
	"Žádné další časové podmínky nejsou dostupné": "No additional time conditions available",
	"Žádné další šablony nejsou dostupné": "No additional templates available",
	"Žádné frontové hovory": "No queued calls",
	"Žádné frontové požadavky": "No queue requests",
	"Žádné fronty nejsou dostupné": "No more queues available",
	"Žádné fronty nejsou k dispozici": "No queues available",
	"Žádné headsety nejsou připojené": "No headsets are attached",
	"Žádné hovory neproběhly": "No calls have been made",
	"Žádné kampaně nejsou aktivní": "No campaigns are active",
	"Žádné kontakty": "No contacts",
	"Žádné skupiny nejsou dostupné": "No groups available",
	"Žádné tickety nebyly nalezeny": "No tickets were found",
	"Žádné vydané nabídky.": "No issued offers.",
	"Žádné výsledky": "No results",
	"Žádné zaparkované hovory": "No parked calls",
	"Žádné záznamy k dispozici": "No recordings are available",
	"Žádní další uživatelé nejsou dostupní": "No other users available",
	"Žádný aktivní hovor": "No call in progress",
	"Žádný kontakt nesplňuje nastavená kritéra vyhledávání": "No contact matches the search criteria",
	"Žádný trunk není nastaven pro přístup k veřejné telefonní sítí.": "No trunk is configured for public telephone network access.",
	"Žádný trunk není nastaven pro tísňová volání. Volání na tísňové linky je BLOKOVANÉ.": "No trunk is configured for emergency calls. Calls to emergency lines are BLOCKED.",
	"∑ Délka hovorů": "∑ Duration of calls",
	"⌀ Délka hovoru": "⌀ Call duration",
	"⌀ Délka v IVR": "⌀ Length in IVR",
	"⌀ Délka vyzvánění": "⌀ Ringing duration",
	"⌀ Hovor In": "⌀ Call duration In",
	"⌀ Hovor Out": "⌀ Call duration Out",
	"⌀ Zvonění In": "⌀ Ringing In",
	"__plural": function(n) { return (n != 1) ? 1 : 0; },
	"__nplurals": 2
};
i18n.langs.de = {
	"Agent je přihlášen ve {n} frontách": [
		"Agent je přihlášen v {n} frontě",
		"Agent je přihlášen ve {n} frontách",
		"Agent je přihlášen v {n} frontách"
	],
	"Importováno {n} záznamů": [
		"",
		""
	],
	"Musí být telefonní číslo": "Vybrán *{n} adresář*",
	"Neexistující cílové callflow {name}": "Vybrán *{n} adresář*",
	"Service\nlevel": "Úroveň služby",
	"Service level": "Úroveň služby",
	"Telefonní číslo (vstupní)": "Vybrán *{n} adresář*",
	"Vyberte adresář": "Vybrán *{n} adresář*",
	"Vyberte call flow": "Vybrán *{n} adresář*",
	"Vyberte cílovou frontu": "Vybrán *{n} adresář*",
	"Vyberte cílovou linku": "Vybrán *{n} adresář*",
	"Vyberte cílové call flow": "Vybrán *{n} adresář*",
	"Vyberte filtr ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte frontu": "Vybrán *{n} adresář*",
	"Vyberte hlášku": "Vybrán *{n} adresář*",
	"Vyberte hlášku ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte linku ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte linku...": "Vybrán *{n} adresář*",
	"Vyberte skupinu ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte telefonní číslo": "Vybrán *{n} adresář*",
	"Vyberte uživatele": "Vybrán *{n} adresář*",
	"Vyberte volbu ze seznamu": "Vybrán *{n} adresář*",
	"Vyberte z voleb": "Vybrán *{n} adresář*",
	"Vyberte číslo": "Vybrán *{n} adresář*",
	"Vyberte číslo ze seznamu": "Vybrán *{n} adresář*",
	"Vybráno *{n} adresářů*": [
		"Vybrán *{n} adresář*",
		"Vybrány *{n} adresáře*",
		"Vybráno *{n} adresářů*"
	],
	"Vybráno *{n} front*": [
		"Vybrána *{n} fronta*",
		"Vybrány *{n} fronty*",
		"Vybráno *{n} front*"
	],
	"Vybráno *{n} komunikačních kanálů*": [
		"",
		""
	],
	"Vybráno *{n} linek*": [
		"Vybrána *{n} linka*",
		"Vybrány *{n} linky*",
		"Vybráno *{n} linek*"
	],
	"Vybráno *{n} pauz*": [
		"Vybrána *{n} pauza*",
		"Vybrány *{n} pauzy*",
		"Vybráno *{n} pauz*"
	],
	"Vybráno *{n} položek*": [
		"Vybrána *{n} položka*",
		"Vybrány *{n} položky*",
		"Vybráno *{n} položek*"
	],
	"Vybráno *{n} uživatelů*": [
		"Vybrán *{n} uživatel*",
		"Vybráni *{n} uživatelé*",
		"Vybráno *{n} uživatelů*"
	],
	"Vybráno *{n} záložek*": [
		"Vybrána *{n} položka*",
		"Vybrány *{n} položky*",
		"Vybráno *{n} položek*"
	],
	"Vybráno *{n} záznamníků*": [
		"Vybrána *{n} linka*",
		"Vybrány *{n} linky*",
		"Vybráno *{n} linek*"
	],
	"Vybráno *{n} časových podmínek*": [
		"",
		""
	],
	"Vybráno *{n} šablon*": [
		"Vybrána *{n} šablona*",
		"Vybrány *{n} šablony*",
		"Vybráno *{n} šablon*"
	],
	"Vzdalené číslo": "Vybrán *{n} adresář*",
	"{n} záznamů se importovat nepodařilo": [
		"",
		""
	],
	"__plural": function(n) { return (n != 1) ? 1 : 0; },
	"__nplurals": 2
};

for (let entries of Object.values(i18n.langs)) {
	entries.__get_plural_index = entries.__plural;
}

function _l(lang, msgid) {
	return _lc(lang, msgid);
}

function _lc(lang, msgid, context) {
	let translation = i18n.langs[lang][(typeof context != 'undefined' ? context + '|' : '') + msgid];

	return typeof translation == 'string' ? translation : msgid;
}

function _ln(lang, n, msgid) {
	return _lnc(lang, n, msgid);
}

function _lnc(lang, n, msgid, context) {
	let translation = i18n.langs[lang][(typeof context != 'undefined' ? context + '|' : '') + msgid];
	if (translation) {
		msgid = translation[i18n.langs[lang].__get_plural_index(n)] || msgid;
	}

	return msgid.replace(/{n}/, n);
}

function _(msgid) {
	return _lc(i18n.lang, msgid);
}

function _c(msgid, context) {
	return _lc(i18n.lang, msgid, context);
}

function _n(n, msgid) {
	return _lnc(i18n.lang, n, msgid);
}

function _nc(n, msgid, context) {
	return _lnc(i18n.lang, n, msgid, context);
}
